<!-- 幸运抽奖 -->
<template>
  <div class="createPlayStep new-input-box">
    <!-- 头部返回 -->
    <div class="backBox">
      <!-- <img class="pointer" @click="returnBack()" src="https://cdn-image.yucrm.cn/images/jd-front-platform/thdImg/pages/back.svg" alt="" /> -->
      <jd-button type="blue" :styleTextObj="{width:'44px',height: '24px','line-height': '24px',padding: '0 8px','min-width': '44px'}" @click="returnBack()">返回</jd-button>
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="localStepNum">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>

      <!-- 选中活动模板 -->

      <!-- 活动条件表单设置 -->
      <div class="secondstep" v-if="localStepNum == 0||localStepNum == 1">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="backgroundForm" label-width="140px">
          <informationForm
            v-if="activityStartTime&&activityEndTime" 
            @selectPeopleSure="selectPeopleSure" 
            :defaultActMember.sync="actMember" 
            :defaultActivityStartTime.sync="activityStartTime" 
            :defaultActivityEndTime.sync="activityEndTime" 
            :plusObject.sync="ruleForm.ruleDTO.plusObject" 
            :isCheckOpenCardTime.sync="ruleForm.ruleDTO.isCheckOpenCardTime" 
            :openCardStartTime.sync="ruleForm.ruleDTO.openCardStartTime" 
            :openCardEndTime.sync="ruleForm.ruleDTO.openCardEndTime" 
            :peopleSelected.sync="peopleSelected"
            ref="informationForm" 
            v-model="ruleForm" 
            :disabled="activityData.isStart" 
            :localStepNum="localStepNum"
            :needNonMember="true" 
            :customerPaperwork="customerPaperwork"
            @handlCorwdTips="customerPaperwork = $event;$forceUpdate()"
            >
          </informationForm>
          <jd-title label='抽奖机会' type="bold"></jd-title>
          <el-form-item label="获取抽奖机会方式:" required>
            <el-radio v-model="raffleForm.drawType" :disabled="activityData.isStart" :label="1">任务赠送</el-radio>
            <el-radio v-model="raffleForm.drawType" :disabled="activityData.isStart" :label="0">消耗积分</el-radio>
          </el-form-item>
          <el-form-item label="免费赠送:" v-if="raffleForm.drawType == 1">
            <el-radio :label="1" v-model="raffleForm.taskType">
              首次赠送
              <el-input
                v-model.number="raffleForm.firstGiveTimes"
                placeholder="请输入"
                @input="raffleForm.firstGiveTimes = getNumberData(1, $event, 0, 0)"
                style="width: 80px"
                :disabled="activityData.isStart"
              ></el-input>
              次
            </el-radio>
            <el-radio :label="2" v-model="raffleForm.taskType">
                每天
              <el-input
                v-model.number="raffleForm.everyDayGiveTimes"
                placeholder="请输入"
                @input="raffleForm.everyDayGiveTimes = getNumberData(1, $event, 0, 0)"
                style="width: 80px"
                :disabled="activityData.isStart"
              ></el-input>
              次
            </el-radio>
          </el-form-item>
          <el-form-item label="积分抽奖:" required v-else>
            用户消耗
            <el-input v-model.number="raffleForm.point" :disabled="activityData.isStart" placeholder="请输入..." style="width: 80px" @input="bigTurntable.point = getNumberData(1, $event, 0, 1)"></el-input>
            积分抽奖一次
          </el-form-item>
          <el-form-item label="赠送限制:" v-if="raffleForm.drawType == 1">
            <el-radio :label="0" v-model="raffleForm.giveLimitType" :disabled="activityData.isStart">
              不限制
            </el-radio>
            <el-radio :label="1" v-model="raffleForm.giveLimitType" :disabled="activityData.isStart">
              满足参与身份才赠送机会
            </el-radio>
          </el-form-item>
          <el-form-item label="任务获取:" v-if="raffleForm.drawType == 1">
            <div class="task-btn-wrap">
              <jd-button v-if="!activityData.isStart" type="blue" @click="addTask">+添加任务</jd-button>
            </div>
            <jd-table
              v-if="taskDataList.length > 0"
              :tableData="taskDataList"
              style="width: 100%;"
            >
              <el-table-column label="任务" width="80px">
                <template slot-scope="scope">
                  <span>任务{{scope.$index + 1}}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务类型">
                <template slot-scope="scope">
                  <span>{{getTaskType(scope.row.type)}}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务条件" prop="condition">
                <template slot-scope="scope">
                  <span style="white-space: pre;">{{getCondition(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column label="任务次数" prop="count">
                <template slot-scope="scope">
                  <span>{{getCount(scope.row)}}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <jd-button :disabled="(scope.row.type!=20&&activityData.isStart) || (activityData.isStart&&scope.row.type==20&&scope.row.skuType==0)" type="blueText" style="margin-right:8px" @click="editTask(scope.row,false)">修改</jd-button>
                  <jd-button type="blueText" style="margin-right:8px" @click="editTask(scope.row,true)">查看</jd-button>
                  <jd-button :disabled="activityData.isStart" type="blueText" style="margin-right:8px" @click="deleteTask(scope.row)">删除</jd-button>
                  <jd-button :disabled="activityData.isStart" type="blueText" style="margin-right:8px" @click="upTask(scope.$index)" v-if="scope.$index != 0">上移</jd-button>
                  <jd-button :disabled="activityData.isStart" type="blueText" @click="downTask(scope.$index)" v-if="scope.$index != taskDataList.length - 1">下移</jd-button>
                </template>
              </el-table-column>
            </jd-table>
          </el-form-item>
          <jd-title label='奖品设置' type="bold"></jd-title>
          <el-form-item label="抽奖和中奖限制:">
            <div class="limit">
              <p>
                每人<span class="c">每天</span>最多抽奖次数
                <el-input
                  v-model.number="bigTurntable.oneDayMaxDrawNumber"
                  placeholder="请输入"
                  @input="bigTurntable.oneDayMaxDrawNumber = getNumberData(1, $event, 0, 1)"
                  style="width: 80px"
                  :disabled="activityData.isStart"
                ></el-input>
                次, 活动期间<span class="c">累计抽奖</span>最多
                <el-input
                  v-model.number="bigTurntable.totalMaxDrawNumber"
                  placeholder="请输入"
                  @input="bigTurntable.totalMaxDrawNumber = getNumberData(1, $event, 0, 1)"
                  style="width: 80px"
                  :disabled="activityData.isStart"
                ></el-input>
                次,
              </p>
              <p>
                活动期间每人<span class="c">每天</span>中奖不超过
                <el-input
                  v-model.number="bigTurntable.oneDayMaxRewardNumber"
                  placeholder="请输入"
                  style="width: 80px"
                  @input="bigTurntable.oneDayMaxRewardNumber = getNumberData(1, $event, 0, 1)"
                  :disabled="activityData.isStart"
                ></el-input>
                次, <span class="c">累计</span>中奖不超过
                <el-input
                  v-model.number="bigTurntable.totalMaxRewardNumber"
                  placeholder="请输入"
                  style="width: 80px"
                  @input="bigTurntable.totalMaxRewardNumber = getNumberData(1, $event, 0, 1)"
                  :disabled="activityData.isStart"
                ></el-input>
                次,
              </p>
              <div style="width: 520px">
                <jd-tip>
                  此处是对抽奖次数和中奖次数做限制。上面次数不填写，表示不限制
                </jd-tip>
              </div>
            </div>
          </el-form-item>

          <el-form-item label="抽奖形式:" required>
            <el-radio-group v-model="ruleForm.luckyDrawForm" @input="changeLayout" :disabled="activityData.isStart">
              <el-radio :label="1">大转盘</el-radio>
              <el-radio :label="2">九宫格</el-radio>
              <el-radio :label="3">拆盲盒</el-radio>
              <el-radio :label="4">幸运翻卡</el-radio>
            </el-radio-group>
          </el-form-item>
          <!-- 概率配置 -->
          <el-form-item label="概率配置类型:">
            <el-radio-group @change="handleProbabilityChange" v-model="probabilityType">
              <el-radio 
                v-for="option in probabilityConfigOptions" 
                :key="option.value" 
                :label="option.value"
              >
                {{ option.label }}
              </el-radio>
            </el-radio-group>
            <el-tooltip class="item" effect="dark" placement="bottom">
              <template slot="content">
                <div>固定概率：所有抽奖机会概率均一致；</div>
                <div>按任务配置概率：可选择通过指定任务获取的抽奖机会进行单独配置中奖概率；</div>
              </template>
              <el-button type="text" style="width: 35px;">
                <i style="color: #ccc" class="el-icon-question"></i>
              </el-button>
            </el-tooltip>
          </el-form-item>
          <!-- 按任务配置时显示任务选择 -->
          <el-form-item v-if="probabilityType == 1" label="选择任务:">
            <el-checkbox-group v-model="selectedTaskTypes" @change="handleTaskTypesChange" >
              <el-checkbox 
                v-for="task in availableTaskOptions" 
                :key="task.value" 
                :label="task.value"
              >
                {{ task.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <!-- 按任务配置时显示的tab栏 -->
          <el-form-item v-if="probabilityType == 1 && selectedTaskTypes.length > 0">
            <el-tabs class="tab-roi-box" v-model="activeProbabilityTab" @tab-click="handleTabClick">
              <el-tab-pane 
                v-for="tab in dynamicProbabilityTabs" 
                :key="tab.name"
                :label="tab.label" 
                :name="tab.name"
              >
              </el-tab-pane>
            </el-tabs>
          </el-form-item>
          <el-form-item required>
            <span slot="label" class="set">奖品设置:</span>
            <div class="termAdd">
              <el-popover placement="right" width="270" trigger="hover">
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/wzsyt.png" alt="" />
                <span slot="reference">位置示意图</span>
              </el-popover>
              <p>
                累计中奖率: <span class="add">{{ winningRate }} %</span>
              </p>
            </div>
            <jd-table
              :tableData="currentPrizeList"
              style="width: 100%;"
            >
              <el-table-column label="位置" width="100">
                <template slot-scope="scope">
                  <span v-if="scope.row.index == 0">一</span>
                  <span v-if="scope.row.index == 1">二</span>
                  <span v-if="scope.row.index == 2">三</span>
                  <span v-if="scope.row.index == 3">四</span>
                  <span v-if="scope.row.index == 4">五</span>
                  <span v-if="scope.row.index == 5">六</span>
                  <span v-if="scope.row.index == 6">七</span>
                  <span v-if="scope.row.index == 7">八</span>
                  <span v-if="scope.row.index == 8">九</span>
                </template>
              </el-table-column>

              <el-table-column label="选择奖品">
                <template slot-scope="scope">
                  <jd-button v-if="!isTaskTab && !activityData.isStart" type="blueText" @click="centerVis(scope.row)">选奖品</jd-button>
                  <jd-button type="blueText"  v-else>选奖品</jd-button>
                </template>
              </el-table-column>

              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  {{ getPrizeTypeName(scope.row.prizeType) }}
                  <!-- <span v-if="scope.row.prizeType == 1">优惠券</span>
                  <span v-if="scope.row.prizeType == 2">京豆</span>
                  <span v-if="scope.row.prizeType == 3">实物</span>
                  <span v-if="scope.row.prizeType == 4">店铺积分</span>
                  <span v-if="scope.row.prizeType == 5">京东E卡</span>
                  <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                  <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                  <span v-if="scope.row.prizeType == 8">现金红包</span>
                  <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                  <span v-if="scope.row.prizeType == 10">礼品卡</span>
                  <span v-if="scope.row.prizeType == 12">{{venderType? '令牌' : '专享价'}}</span> -->
                </template>
              </el-table-column>

              <el-table-column label="值" width="80" prop="price">
              </el-table-column>

              <el-table-column label="奖品名称（12字内）" width="299">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.title"
                    maxlength="12"
                    :disabled="scope.row.prizeType == 9||isTaskTab"
                    show-word-limit
                    style="width: 240px"
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column label="奖品总数" width="180">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.totalAmount"
                    @input.native="(e) => (scope.row.totalAmount = checkputn(e, scope.row, 'jindou'))"
                    placeholder="请输入"
                    style="width: 80px"
                    @input="scope.row.totalAmount = getNumberData(1, $event, 0, 1),prizeNum(scope.row)"
                    @blur="beAdd(scope.row)"
                    :disabled="isTaskTab || activityData.isStart && !scope.row.minNum || activityData.isStart"
                  ></el-input>
                  份
                </template>
              </el-table-column>

              <el-table-column label="每日发放限额" width="180" align="center">
                <template slot-scope="scope">
                  <div style="text-align: center" @click="setLimit(scope.row)">
                    <jd-button :disabled="isTaskTab" v-if="!scope.row.dailyLimitType && !scope.row.dailyLimit" type="blueText">
                      配置
                    </jd-button>
                    <jd-button :disabled="isTaskTab" v-if="scope.row.dailyLimitType == 0 && scope.row.dailyLimit" type="blueText">
                      每日发放{{ scope.row.dailyLimit }}份
                    </jd-button>
                    <div v-if="scope.row.dailyLimitType == 1">
                      <div>
                        <jd-button :disabled="isTaskTab" type="blueText">闲时发放{{ scope.row.idleLimit }}份</jd-button>
                      </div>
                      <div>
                        <jd-button :disabled="isTaskTab" type="blueText">忙时发放{{ scope.row.busyLimit }}份</jd-button>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
<!--   @input="scope.row.percentage = getNumberData(1, $event, 1, 0,100)" -->
<!--     @input="scope.row.percentage = handleInputPrice($event)" -->
              <el-table-column label="中奖率" width="130">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.percentage"
                    placeholder="请输入"
                    style="width: 90px"
                    @keyup.native="scope.row.percentage = oninput2(scope.row.percentage,scope.$index)"
                    :disabled="!activityData.status ? false : !scope.row.totalAmount ? true : false"
                  ></el-input>
                  %
                </template>
              </el-table-column>
              <el-table-column label="最多中奖次数" width="130">
                <template #header>
                    <el-tooltip
                      effect="light"
                      content="当单个用户中奖次数达到设定上限后，后续抽奖不再分配该奖品，系统自动重配其他奖品。"
                      placement="right"
                    >
                      <div>
                        最多中奖次数<i style="color: #ccc;" class="el-icon-question"></i>
                      </div>
                    </el-tooltip>
                </template>
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.singleMaxWin"
                    placeholder="请输入"
                    style="width: 80px"
                    @input="scope.row.singleMaxWin = getNumberData(1, $event, 1, 0, 9999)"
                    :disabled="
                      isTaskTab ||
                      !activityData.status
                        ? isTaskTab ? true : false
                        : !scope.row.totalAmount
                        ? true
                        : activityData.isStart ? true : false
                    "
                  ></el-input>
                </template>
              </el-table-column>

              <el-table-column label="图片" width="170">
                <template slot-scope="scope">
                  <img v-if="scope.row.logo" :src="scope.row.logo" style="width: 56px; height: 56px" />
                </template>
              </el-table-column>
              <el-table-column label="入会且已购中奖率" width="150">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.memberBuyPercentage"
                    @input="scope.row.memberBuyPercentage = getNumberData(1, $event, 1, 0,100)"
                    placeholder="请输入"
                    style="width: 80px"
                    @keyup.native="scope.row.memberBuyPercentage = oninput2(scope.row.memberBuyPercentage,scope.$index,2)"
                    :disabled="!activityData.status ? false : !scope.row.totalAmount ? true : false"
                  ></el-input>
                  %
                </template>
              </el-table-column>
              <el-table-column label="操作" width="160">
                <template slot-scope="scope">
                  <jd-button v-if="!activityData.isStart && !isTaskTab" type="blueText" @click="cleanData(scope.row, scope.$index)">清除</jd-button>
                  <jd-button v-else  type="blueText" >清除</jd-button>
                  <jd-button type="blueText" style="margin-left: 5px" v-if="!isTaskTab && activityData.isStart && scope.row.title && scope.row.title !='谢谢参与'"
                    @click="itemAddNum('prizeSettingList', scope.$index)">增加奖品数量</jd-button>
                </template>
              </el-table-column>
            </jd-table>
            <div style="color: red;" v-if="activityData.isStart">提示：修改奖品名称后，已领取的奖品记录依旧不变更名称</div>
            <div style="margin-top: 12px">
              <jd-tip>
                <div>
                  说明<br/>
                  <p>
                    1、最多设置{{ruleForm.luckyDrawForm==4?6:ruleForm.luckyDrawForm==3?9:8}}个奖项；设置的奖项不足{{ruleForm.luckyDrawForm==4?6:ruleForm.luckyDrawForm==3?9:8}}个时，系统自动补充“谢谢参与”
                  </p>
                  <p>
                    2、中奖率/入会且已购中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”
                  </p>
                  <p>
                    3、为避免客诉，奖品中奖概率不建议设置为0；若奖品中奖概率一定要设置为0，一切后果由商家承担；
                  </p>
                  <p>
                    4、进行中的活动修改中奖概率有一定客诉风险，不建议频繁修改。
                  </p>
                </div>
                
              </jd-tip>
            </div>
          </el-form-item>
          <el-form-item label="特殊设置：">
              <el-checkbox
                v-model="ruleForm.guaranteedWinPrizeFlag"
                :disabled="winningRate != 100 || activityData.isStart"
                :true-label="1"
                :false-label="0"
                >开启100%中奖</el-checkbox
              >
              <div
                style="
                  line-height: 20px;
                  font-size: 14px;
                  color: #f89f39;
                "
              >
                <div>
                  1、必须配置有奖的奖品概率相加为100%才能勾选【开启100%中奖】，勾选后如有奖品库存发完后，将等比放大其他有库存奖品的概率，总合计概率值仍为100%。如果所有奖品的库存都全部发完，用户将无法中奖。C端用户抽奖将提示：所有奖品已经被抢光啦！
                </div>
                <div>
                  2、如不勾选，则表示部分奖品的库存发完后，其他奖品的中奖概率也不变，剩余部分概率自动分配给“谢谢参与”。
                </div>
                <div>
                  3、如勾选【开启100%中奖】，建议不要设置“每日发放上限”和“中奖限制”，否则达到上限后将无法中奖!
                </div>
              </div>
            </el-form-item>
          <jd-title label='进店设置' type="bold"></jd-title>
          <el-form-item label="进店逛逛:">
            <el-radio-group v-model="ruleForm.goShopSetting" :disabled="activityData.isStart" @change="onShopSetChange">
             <el-radio :label="0">进入店铺首页</el-radio>
             <el-radio :label="1">跳转指定小程序</el-radio>
             <el-radio :label="2">进入指定链接</el-radio>
            </el-radio-group>
            <div style="color:#F56C6C">部分活动需要配合曝光商品使用，如幸运抽奖、裂变神券</div>
          </el-form-item>
          <div v-if="ruleForm.goShopSetting==1">
            <el-form-item label="小程序appId:" required>
              <el-input
                type="textarea"
                placeholder="请输入小程序appId"
                style="width: 425px;margin-left:8px;"
                show-word-limit
                v-model="ruleForm.goShopAppId"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            </el-form-item>
           <el-form-item label="页面路径path:">
            <el-input
                type="textarea"
                placeholder="请输入小程序页面路径path"
                style="width: 425px;margin-left:8px;"
                show-word-limit
                v-model="ruleForm.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
              ></el-input>
            <div style="color:#F56C6C">注意：path若不写，则默认进入小程序主页。</div>
           </el-form-item>
          </div>
          <el-form-item label="指定链接:" required v-if="ruleForm.goShopSetting==2">
            <el-input
                type="textarea"
                placeholder="请输入指定链接"
                style="width: 425px;margin-left:8px;"
                show-word-limit
                v-model="ruleForm.goShopUrl"
                :maxlength="1000"
                :disabled="activityData.isStart"
            ></el-input>
            <div style="color:#F56C6C">注意：仅可填写京东域内的 H5页面地址，不可设置外链。参考链接：https://m.jd.com/。</div>
          </el-form-item>
                <!-- :widthNumber="0"
             :heightNumber="1250" -->
          <activityPageSettings 
            isShowShopName
            isShowMoreSet
            :cusTemplateJSON.sync="cusTemplateJSON" 
            :isNeedSetBG="true" 
            :isNeedCustomerPaperworkData="ruleForm.luckyDrawForm==4" 
             :downloadTemplateUrl="luckyDrawTemplateUrl[ruleForm.luckyDrawForm]"
             :designSpecificationsUrl="luckyDrawDesignUrl[ruleForm.luckyDrawForm]"
             :giftList="newGiftList" 
             :templateId="templateId"
             @selectTemplate="selectTemplate"
             :otherSize="ruleForm.luckyDrawForm == 1 ? '联系客服咨询尺寸详情' : ''"
              :widthNumber="widthNumber"
              :heightNumber="heightNumber"
              v-model="customerPaperwork"
              :defaultRgb="currrentRgb"
              themeTitle="主题"
             :templatekey="'secondImageUrl'">
             <template #otherSet>
              <div v-if="ruleForm.luckyDrawForm==2">
                <customUpload
                  :customerPaperwork="customerPaperwork"
                  bgKey="singleGridUrl"
                  labelWidth="138px"
                  :pw="160"
                  :ph="160"
                  labelText="单个宫格图:"
                  bgLabelText="单个宫格图"
                  btnType="blueLine"
                />
                <customUpload
                  :customerPaperwork="customerPaperwork"
                  bgKey="drawBtnUrl"
                  labelWidth="138px"
                  :pw="160"
                  :ph="160"
                  labelText="抽奖按钮图:"
                  bgLabelText="抽奖按钮图"
                  btnType="blueLine"
                />
                <customText
                  :customerPaperwork="customerPaperwork"
                  labelText="选中色号:"
                  labelWidth="138px"
                  colorKey="selectColor"
                  :resetColor="currentSelectColor"
                />
              </div>
              <div v-else-if="ruleForm.luckyDrawForm==3">
                <customUpload
                  :customerPaperwork="customerPaperwork"
                  bgKey="noBlindBoxUrl"
                  labelWidth="160px"
                  :pw="294"
                  :ph="222"
                  labelText="单个盲盒图（未拆盒）:"
                  bgLabelText="单个盲盒图（未拆盒）"
                  btnType="blueLine"
                />
                <customUpload
                  :customerPaperwork="customerPaperwork"
                  bgKey="blindBoxUrl"
                  labelWidth="160px"
                  :pw="294"
                  :ph="222"
                  labelText="单个盲盒图（拆盒）:"
                  bgLabelText="单个盲盒图（拆盒）"
                  btnType="blueLine"
                />
               
                <el-form-item label="按钮字体：" label-width="160px">
                  <div class="flexc">
                    <el-color-picker
                      v-model="customerPaperwork.blindBoxColor"
                      class="mr12"
                    >
                    </el-color-picker>
                    <el-input
                      show-word-limit
                      maxlength="4"
                      class="w120"
                      v-model="customerPaperwork.blindBoxText"
                      placeholder="请输入"
                    ></el-input>
                    <jd-button
                      type="blueText"
                      @click="customerPaperwork.blindBoxColor = currentBlindBoxColor"
                      class="ml16"
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
                <el-form-item label="按钮颜色：" label-width="160px">
                  <div class="flexc">
                    <el-color-picker
                      v-model="customerPaperwork.blindBoxBtnColor"
                      class="colorPicker"
                    >
                    </el-color-picker>
                    <jd-button
                      class="ml16"
                      type="blueText"
                      @click="customerPaperwork.blindBoxBtnColor = currentBlindBoxBtnColor"
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
              </div>
              <div v-else-if="ruleForm.luckyDrawForm==4">
                <customUpload
                  :customerPaperwork="customerPaperwork"
                  bgKey="noSingleFlipCardUrl"
                  labelWidth="160px"
                  :pw="200"
                  :ph="280"
                  labelText="单个翻卡（未翻卡）:"
                  bgLabelText="单个翻卡（未翻卡）"
                  btnType="blueLine"
                >
                  <template #sizeTip>
                    <span>
                        ，格式：jpg、png
                    </span>
                  </template>
                </customUpload>
                <customUpload
                  :customerPaperwork="customerPaperwork"
                  bgKey="singleFlipCardUrl"
                  labelWidth="160px"
                  :pw="200"
                  :ph="280"
                  labelText="单个翻卡（已翻卡）:"
                  bgLabelText="单个翻卡（已翻卡）"
                  btnType="blueLine"
                >
                  <template #sizeTip>
                    <span>
                        ，格式：jpg、png
                    </span>
                  </template>
                </customUpload>
                <customUpload
                  :customerPaperwork="customerPaperwork"
                  bgKey="earnCountUrl"
                  labelWidth="160px"
                  :pw="100"
                  :ph="87"
                  :extensions="['.jpg', '.png','.gif']"
                  accept=".jpg,.png,.gif"
                  labelText="赚次数图:"
                  bgLabelText="赚次数图"
                  btnType="blueLine"
                />
                <el-form-item label="按钮字体:" label-width="160px">
                  <div class="flexc">
                    <el-color-picker
                      v-model="customerPaperwork.flipCardColor"
                      class="mr12"
                    >
                    </el-color-picker>
                    <div
                      class="bold-toggle-btn"
                      :class="{
                        'is-active': customerPaperwork.flipCardFontBold,
                        'is-disabled': backgroundOpacity
                      }"
                      @click="
                        !backgroundOpacity &&
                          (customerPaperwork.flipCardFontBold = !customerPaperwork.flipCardFontBold)
                      "
                    >
                      <span class="bold-toggle-text">B</span>
                    </div>
                    <el-input
                      class="w180 ml12"
                      v-model="customerPaperwork.flipCardText"
                      :maxlength="flipCardTextMaxLength"
                      show-word-limit
                      @input="handleFlipCardTextInput"
                      placeholder="请输入"
                    ></el-input>
                    <jd-button
                      type="blueText"
                      @click="customerPaperwork.flipCardColor = currentFlipCardColor"
                      class="ml16"
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
                <el-form-item label="按钮颜色:" label-width="160px">
                  <div class="flexc">
                    <el-color-picker
                      v-model="customerPaperwork.flipCardBtnColor"
                      class="colorPicker"
                    >
                    </el-color-picker>
                    <jd-button
                      class="ml16"
                      type="blueText"
                      @click="customerPaperwork.flipCardBtnColor = currentFlipCardBtnColor"
                      >重置</jd-button
                    >
                  </div>
                </el-form-item>
              </div>
             </template>
            </activityPageSettings>
          <exposureList :defaultExposureSwitch.sync="ruleForm.exposureSwitch" v-model="itemListFor" :backgroundOpacity="backgroundOpacity"></exposureList>
          <sharFrom :sharePic="sharePic" v-model="ruleForm"></sharFrom>
          <activityRules :activityData="activityData" :valueRow="valueRow" :isForceRemind.sync="isForceRemind" :isKeyActivity.sync="isKeyActivity" :placementPosition.sync="placementPosition" v-model="ruleForm.ruleDescription" @generateRule="generateRule"></activityRules>

          <!-- <div v-if="backgroundOpacity" class="backgroundOpacity" style="height: calc(100% - 45px);"></div> -->
        </el-form>
      </div>
    </div>
    <div class="create_bottom" v-if="localStepNum == 0||localStepNum == 1">
      <jd-button v-if="localStepNum != 0" v-show="!itemId" style="margin-right: 8px" @click="clickLocalStep()">{{
        backgroundOpacity ? "返回列表" : "返回上一步"
      }}</jd-button>
      <jd-button @click="saveDraft" style="margin-right: 8px" v-if="hasDraftBtn">保存至草稿箱</jd-button>
      <template v-if="!backgroundOpacity">
        <jd-button v-show="!itemId"  v-if="isSave"  type="blue" @click="resetForm" v-preventReClick
          >保存设置</jd-button
        >
      </template>

      <jd-button v-show="itemId" style="margin-right: 8px" @click="cancelEdit">取消</jd-button>
      <jd-button v-show="itemId" type="blue">保存设置</jd-button>
    </div>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      v-if="selectGoodsState"
      ref="selectGo"
      :isShow="selectGoodsState"
      @close="selectGoodsClose"
      :selectGoods="selectGoodsArr"
      :moduleType="true"
      :skuSearch="true"
      :xianz="true"
      :disabled="backgroundOpacity"
      isInteract
    ></selectGoodsMonitor>

    <!-- 选择奖品弹窗 -->
    <selectProduct ref="selectProduct" :endTime="activityEndTime" activityType="8" v-if="isSelectProduct" :echoDate="echoDate" :actId="valueRow" :num="1" :JingdouCount="JingdouCount" @choose-shop="getTheData" :notBaidu="activityData.id == 8 ? true : false" :actType="8" :actEndTime="ruleForm.endTime">
    </selectProduct>

    <!-- 保存设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800" @close="checked = false">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <jd-button @click="joinBlackList = false">取 消</jd-button>
        <jd-button @click="handleDialogCloseAnoth()" type="blue" style="margin-left: 8px">确 定</jd-button>
      </div>
    </el-dialog>
    <!-- 添加任务 -->
    <el-dialog :title="`${isTaskEdit?'修改任务':'添加任务'}`" :visible.sync="taskDialog" :width="taskForm.type == 20 ? '750px' : taskForm.type == 17 ? '800px' : '670px'" @close="taskClose" v-if="taskDialog">
      <el-form :model="taskForm" style="position: relative;" class="new-input-box" label-position="left">
        <div v-if="taskIsLook" style="position:absolute;width: 100%;height: 100%;left: 0;top:0;z-index: 5;"></div>
        <el-form-item label="任务类型:" label-width="100px" required>
          <el-select
            v-model="taskForm.type" 
            style="width: 350px"
            @change="taskTypeChange"
            :disabled="activityData.isStart&&taskForm.type == 20"
          >
            <el-option
              v-for="item in taskTypeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <div class="task-tip-wrap">
          <jd-tip class="task-tip" v-if="taskForm.type == 1">
            <div>任务说明：用户每日都可进入活动页签到，获得抽奖机会。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 2">
            <div>任务说明：用户每日都可进入活动页浏览店铺，获得抽奖机会。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 13">
            <div>任务说明：</div>
            <div>1.用户浏览商品可以获得抽奖机会；</div>
            <div>2.商品是以单个SKU为单位，浏览同一个商品多次按1次计算；</div>
            <div>3.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 4">
            <div>任务说明：</div>
            <div>1.用户成功加购商品可以获得抽奖机会；</div>
            <div>2.商品是以单个SKU为单位，加购同一个商品多次按1次计算；</div>
            <div>3.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 9">
            <div>任务说明：</div>
            <div>1.用户成功分享商品可以获得抽奖机会；</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 10">
            <div>任务说明：</div>
            <div>1.用户成功分享店铺可以获得抽奖机会；</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 11">
            <div>任务说明：</div>
            <div>1.用户成功分享活动可以获得抽奖机会；</div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 8">
            <div>任务说明：</div>
            <div>1.用户成功邀请好友可以获得抽奖机会；</div>
            <div>2.被邀请人只有点击助力链接才算一次有效助力，且活动期间每人只有1次助力机会；</div>
            <div>3.用户在活动期间内可以做此任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 5">
            <div>任务说明：</div>
            <div>1.此任务可以放链接，必须遵从以下规则：</div>
            <div>
              （1） 链接须包含 .isvjcloud.com，.isvjd.com或.jd.com
            </div>
            <div>
              （2） 只能以http://,https://开头
            </div>
            <div>2.用户每日都可以进入活动做任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 12">
            <div>任务说明：</div>
            <div>1.用户成功预约商品可以获得抽奖机会；</div>
            <div>2.商品是以单个SKU为单位，预约同一个商品多次按1次计算；</div>
            <div>3.用户在活动时间期间内可以做此任务。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 16">
            <div>任务说明：用户消耗一定积分可兑换抽奖机会次数。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 17">
            <div>
              <div>任务说明：</div>
              <div>
                1、因官方接口限制，POP统计订单实付金额，自营统计订单金额（是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。）；
              </div>
              <div>2、指定购买商品：订单包含任意指定商品均会被统计；</div>
              <div>
                3、选择订单状态为“已完成”，则仅限交易完成的订单可获得抽奖机会，如：活动已结束，交易未完成，则不赠送次数；
              </div>
              <div>
                4、如买家通过消费任务获得次数后进行退款的情况，已赠送的次数不会撤回；
              </div>
              <div style="color: #fe4d45">
                5、如设置【购物任务】条件，则活动对象设置必须为会员身份，接口限制非会员无法统计交易数据。
              </div>
            </div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 18">
            <div>任务说明：用户邀请好友成功入会，可获取中奖机会；</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 7">
            <div>任务说明：用户可参与入会任务，增加抽奖机会。</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type==20">
            <div>任务说明：用户成功预定预售商品且支付定金可以获取抽奖机会;</div>
          </jd-tip>
          <jd-tip class="task-tip" v-if="taskForm.type == 23">
            <div>任务说明：此任务可以放搜索关键词，用户进入活动点击去搜索自动带【关键词】跳转至APP查询页查询；</div>
          </jd-tip>
        </div>
        <el-form-item label="任务有效期:" label-width="110px" required>
          <div class="task-wrap">
            <div class="task-wrap-radio">
              <el-radio :disabled="activityData.isStart&&taskForm.type == 20" v-model="taskForm.taskTime" :label="1">长期有效</el-radio>
              <el-radio :disabled="activityData.isStart&&taskForm.type == 20" v-model="taskForm.taskTime" :label="2">指定日期</el-radio>
            </div>
            <div class="my_select_time" v-if="taskForm.taskTime == 2">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="taskForm.startTime"
                  type="date"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 120px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :disabled="activityData.isStart&&taskForm.type == 20"
                  @change="activityTimeChange"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="taskForm.endTime"
                  type="date"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  style="width: 120px; font-size: 12px"
                  class="time2"
                  :disabled="activityData.isStart&&taskForm.type == 20"
                  :clearable="false"
                >
                </el-date-picker>
                <i class="el-icon-circle-close date_icon1" v-if="!activityData.isStart" @click="clearTaskTime()"></i>
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt="" class="date_icon2" />
            </div>
          </div>
        </el-form-item>
        <el-form-item label="邀请人数上限:" label-width="110px" required v-if="taskForm.type == 8">
          <span>
            <el-input
              v-model.number="taskForm.inviteLimit"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.inviteLimit = getNumberData(1, $event, 0, 1)"
            ></el-input>
          </span>
          人
        </el-form-item>
        <el-form-item label="跳转链接:" label-width="110px" required v-if="taskForm.type == 5">
          <el-input
            v-model="taskForm.jumpUrl"
          ></el-input>
          <div>
            <span class="tip-red">注：跳转的链接必须为京东链接</span>
          </div>
        </el-form-item>
        <template v-if="taskForm.type == 17">
          <el-form-item label="奖励规则："  label-width="110px" required>
            <el-select
              v-model="taskForm.giveType" 
              :disabled="activityData.isStart"
              style="width: 200px"
              @change="giveTypeChange">
              <el-option
                v-for="item in rewardRulesOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-tooltip class="item" effect="light" placement="right" style="margin-left: 8px">
              <div slot="content">
                1、按固定次数赠送抽奖机会：例如设置【满10元及以上赠送1次机会】，若用户下单100元，则也只赠送1次机会；
                <br/>
                2、按倍数赠送抽奖机会：例如设置【每满100元及以上赠送1次机会】，若按单笔，则用户第一次下单90元，则未达到赠送条件，第二次下单110元，则赠送1次机会；
                <br/>
                若按累计，则用户第一次下单90元，未达到赠送条件；第二次下单110元，两笔订单合起来为200元，则赠送2次抽奖机会
                <br/>
                3、按阶梯赠送抽奖机会：例如设置多阶梯【满10元及以上赠送1次机会，满30元及以上赠送3次机会】，若按单笔，用户第一次下单10元，则赠送1次机会，第二次下单20元，满足“满10元未达到30元”，则赠送1次
                <br/>
                若按累计，用户下单10元，则本次赠送1次机会，该用户再次下单20元，此时满足第二个阶梯30元，但是由于已经赠送了1次机会，所以再次赠送2次机会。达到满30元赠送3次机会的设置。
                <br/>
              </div>
              <div style="display: inline-flex;cursor: pointer;align-items: center;">
                奖励规则说明<i class="el-icon-question" style="color: #ccc;margin-left: 2px;"></i>
              </div>
            </el-tooltip>
            <div class="rule_box">
              <el-form-item label="下单店铺:" required>
                <orderShopCom
                  :venderIds.sync="taskForm.venderIds"
                  :multiShopGoods.sync="multiShopGoods"
                  :sellerSkuList.sync="taskForm.sellerSkuList"
                />
              </el-form-item>
              <el-form-item label="下单时间：" label-width="100px" required>
                <div class="my_select_time">
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="taskForm.orderStartTime"
                    :picker-options="taskstartpickerOptionsValue"
                    type="datetime"
                    placeholder="开始日期"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    style="width: 148px; font-size: 12px"
                    class="time1"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <div class="time_to_text">至</div>
                  <el-date-picker
                    prefix-icon="no_icon"
                    v-model="taskForm.orderEndTime"
                    :picker-options="taskpickerOptionsValueEnd"
                    type="datetime"
                    placeholder="结束日期"
                    size="small"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    default-time="23:59:59"
                    style="width: 152px; font-size: 12px"
                    class="time2"
                    :clearable="false"
                  >
                  </el-date-picker>
                  <i class="el-icon-circle-close date_icon1" v-if="!activityData.isStart" @click="clearOrderTime()"></i>
                  <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt="" class="date_icon2" />
                </div>
                <el-tooltip class="item" effect="light" content="最长时间跨度不超过90天" placement="bottom" style="margin-left: 8px">
                  <div style="width: 35px; display: inline-flex;cursor: pointer;">
                    <i class="el-icon-question" style="color: #ccc"></i>
                  </div>
                </el-tooltip>
              </el-form-item>
              <el-form-item label="金额统计类型:" required>
                <el-radio-group
                  v-model="taskForm.orderPaymentType"
                >
                  <el-radio :label="1">
                    <span>订单金额（后台价）</span>
                    <el-tooltip class="item" effect="dark" content="是指京东后台价，不等于商城前台页面展示的价格，前台页面无法查看该后台价格；如需查询后台价格，请联系采销核实。" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                  <el-radio :label="0" v-if="!isVenderType">
                    <span>用户应付金额</span>
                    <el-tooltip class="item" effect="dark" content="订单商品原价总额-订单优惠总额+订单运费+税费+调整运费金额=用户应付金额" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                  <el-radio :label="2" v-if="!isVenderType">
                    <span>用户实付金额</span>
                    <el-tooltip class="item" effect="dark" content="用户应付金额-支付优惠总额=用户实付金额" placement="top-start">
                      <div class="new-icon-box" style="margin: -3px 8px"></div>
                    </el-tooltip>
                  </el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="商品要求：" label-width="100px" required class="skuType-label">
                <!-- <el-radio v-model="taskForm.skuType" :label="0">全部商品</el-radio>
                <el-radio v-model="taskForm.skuType" :label="1">指定商品</el-radio>
                <div style="display: inline-block">
                  <jd-button type="blue" @click="showGoods(100)" :disabled="taskForm.skuType != 1">选择商品（{{taskForm.skuIds.length}}/100）</jd-button>
                </div> -->
                <productReqCom
                  :filterType.sync="taskForm.skuType"
                  :venderIds.sync="taskForm.venderIds"
                  :sellerSkuList.sync="taskForm.sellerSkuList"
                  :multiShopGoods.sync="multiShopGoods"
                  :isShowExclude="false"
                  :limitNum="goodsLimit"
                  addGoodText="选择商品"
                />
              </el-form-item>
              <!-- 指定商品规则：仅商品要求为"指定商品"时展示，0=整单计算 1=仅统计指定商品金额和件数 -->
              <el-form-item label="指定商品规则：" label-width="120px" v-if="taskForm.orderPaymentType==1&&taskForm.skuType == 1">
                <el-select style="width: 280px;" v-model="taskForm.statsSkuType" placeholder="">
                  <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                  <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="订单金额：" v-if="taskForm.giveType == 0"  label-width="100px" required>
                大于等于<el-input style="width: 120px; margin: 0 8px"  v-model="taskForm.amtLimit" @input="validateInput"/>元
              </el-form-item>
              <el-form-item label="商品件数：" v-if="taskForm.giveType == 0" style="margin-left: 12px"  label-width="88px">
                大于等于<el-input style="width: 120px; margin: 0 8px" v-model="taskForm.itemTotalLimit" @input="validateInputNew"/>件
              </el-form-item>
              <el-form-item label="订单拆单后是否合并:" label-width="160px" required>
                <el-radio-group
                  v-model="taskForm.mergeOrder"
                >
                  <el-radio :label="false">否</el-radio>
                  <el-radio :label="true">是</el-radio>
                </el-radio-group>
                <jd-button type="blueText" class="ml12" @click="viewMergeLogic">查看合并拆单逻辑</jd-button>
              </el-form-item>
              <el-form-item label="订单状态：" label-width="100px" required>
                <el-radio-group v-model="taskForm.orderType" @change="handleChangeOrderType">
                <el-radio :label="0">已付款</el-radio>
                <el-radio :label="1">已完成</el-radio>
              </el-radio-group>
              </el-form-item>
              <el-form-item label="统计方式：" label-width="100px" required>
                <el-radio-group v-model="taskForm.orderCountType" @change="handleChangeOrderCountType">
                  <el-radio :label="1" @input="taskForm.condition2 = ''">累计订单</el-radio>
                  <el-radio :label="0" @input="taskForm.condition2 = ''">单笔订单</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-form-item label="统计类型：" v-if="taskForm.giveType == 1||taskForm.giveType == 2"  label-width="100px" required>
                <el-radio @change="countTypeChange" v-model="taskForm.countType" :label="1">按订单金额</el-radio>
                <el-radio @change="countTypeChange"  v-model="taskForm.countType" :label="2">按商品件数</el-radio>
                <el-radio @change="countTypeChange"  v-if="taskForm.orderCountType == 1" v-model="taskForm.countType" :label="3">按订单笔数</el-radio>
              </el-form-item>
              <el-form-item label="任务条件:"  label-width="100px" required>
                  <span v-if="taskForm.orderCountType == 0&&taskForm.giveType == 0">
                    每1个订单赠送1次抽奖机会
                  </span>
                  <span v-else-if="taskForm.orderCountType == 1&&taskForm.giveType == 0">
                    完成任务赠送1次抽奖机会
                  </span>
                  <span v-else-if="taskForm.giveType == 1">
                    <div v-for="(item,index) in taskLevelList" :key="index" style="margin-bottom: 6px;">
                      <span v-if="taskForm.countType == 1">每满<el-input placeholder="请输入金额" v-model="item.limit" style="width: 95px; margin: 0 8px" @input="(e)=>{item.limit = inputValidateInput(e)}"/>元</span>
                      <span v-if="taskForm.countType == 2">每满<el-input placeholder="请输入件数" v-model="item.limit" style="width: 95px; margin: 0 8px" @input="(e)=>{item.limit = inputValidateInputNew(e)}"/>件</span>
                      <span v-if="taskForm.countType == 3">每满<el-input placeholder="请输入笔数" v-model="item.limit" style="width: 95px; margin: 0 8px" @input="(e)=>{item.limit = inputValidateInputNew(e)}"/>笔</span>
                      ，赠送 
                      <el-input v-model.number="item.giveNum" placeholder="请输入次数" style="width: 95px" @input="item.giveNum = getNumberData(1, $event, 0, 1,999)"></el-input>
                      次抽奖机会
                    </div>
                  </span>
                  <span v-else-if="taskForm.giveType == 2">
                    <div v-for="(item,index) in taskLevelList" :key="index" style="margin-bottom: 6px;">
                        <span v-if="taskForm.countType == 1">每满<el-input placeholder="请输入金额" v-model="item.limit" @change="(e)=>{item.limit = NumChange(e,'limit',index)}" style="width: 95px; margin: 0 8px" @input="(e)=>{item.limit = inputValidateInput(e)}"/>元</span>
                        <span v-if="taskForm.countType == 2">每满<el-input placeholder="请输入件数" v-model="item.limit" @change="(e)=>{item.limit = NumChange(e,'limit',index)}" style="width: 95px; margin: 0 8px" @input="(e)=>{item.limit = inputValidateInputNew(e)}"/>件</span>
                        <span v-if="taskForm.countType == 3">每满<el-input placeholder="请输入笔数" v-model="item.limit" @change="(e)=>{item.limit = NumChange(e,'limit',index)}"  style="width: 95px; margin: 0 8px" @input="(e)=>{item.limit = inputValidateInputNew(e)}"/>笔</span>
                        ，赠送 
                        <el-input v-model.number="item.giveNum" @change="(e)=>{item.giveNum = NumChange(e,'giveNum',index)}" placeholder="请输入次数" style="width: 95px" @input="item.giveNum = getNumberData(1, $event, 0, 1,999)"></el-input>
                        次抽奖机会
                        <span  v-if="index>=2" @click="delTaskLevel(index)" style="cursor: pointer;"><i class="el-icon-error"></i></span>
                    </div>
                    <jd-button :disabled="taskLevelList.length>=5" style="margin-right: 8px" @click="addTaskLevel">添加阶梯({{ taskLevelList.length }}/5)</jd-button>
                  </span>
              </el-form-item>
              <el-form-item label="任务次数:" label-width="100px" required>
                  <span v-if="taskForm.orderCountType == 0 && taskForm.giveType == 0">
                    活动期间最多完成
                    <el-input
                    v-model.number="taskForm.condition2"
                    placeholder="请输入"
                    style="width: 70px"
                    @input="taskForm.condition2 = getNumberData(1, $event, 0, 1,999)"
                    ></el-input>
                    次
                  </span>
                  <span v-else-if="taskForm.giveType == 1 || taskForm.giveType == 2">
                    <el-radio v-model="taskForm.taskDoType" :label="0">不限制次数</el-radio>
                    <el-radio v-model="taskForm.taskDoType" :label="1">限制次数</el-radio>
                    <el-tooltip class="item" effect="light" content="限制该任务可获得抽奖次数上限" placement="bottom" style="margin-left: 8px">
                      <div style="width: 35px; display: inline-flex;cursor: pointer;">
                        <i class="el-icon-question" style="color: #ccc"></i>
                      </div>
                    </el-tooltip>
                    <div v-if="taskForm.taskDoType == 1">
                      活动期间最多获得<el-input v-model.number="taskForm.condition2" placeholder="请输入" style="width: 70px" @input="taskForm.condition = getNumberData(1, $event, 0, 1,999)"></el-input>次抽奖机会
                    </div>
                  </span>
                  <span v-else>{{taskForm.count}}</span>
              </el-form-item>
              <el-form-item label="任务失效:" label-width="100px" required v-if="taskForm.giveType==0&&taskForm.orderType==0&&taskForm.orderCountType==0">
                <el-checkbox v-model="taskForm.cancelOrderInvalid" :true-label="1" :false-label="0">用户取消订单后，抽奖机会或使用该抽奖机会的实物奖品失效</el-checkbox>
              </el-form-item>
            </div>
          </el-form-item>
        </template>
        <el-form-item label="奖励规则:" v-else-if="taskForm.type == 20" label-width="110px" required>
          <el-radio-group v-model="taskForm.countType" :disabled="activityData.isStart" @change="handleCountTypeChange">
            <el-radio :label="2">按商品件数赠送抽奖机会</el-radio>
            <el-radio :label="3">按订单笔数赠送抽奖机会</el-radio>
          </el-radio-group>
          <div class="rule_box">
            <el-form-item label="下单时间：" label-width="100px" required>
              <div class="my_select_time">
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="taskForm.orderStartTime"
                  :picker-options="taskstartpickerOptionsValue"
                  type="datetime"
                  placeholder="开始日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  style="width: 148px; font-size: 12px"
                  class="time1"
                  :clearable="false"
                  :disabled="activityData.isStart"
                >
                </el-date-picker>
                <div class="time_to_text">至</div>
                <el-date-picker
                  prefix-icon="no_icon"
                  v-model="taskForm.orderEndTime"
                  :picker-options="taskpickerOptionsValueEnd"
                  type="datetime"
                  placeholder="结束日期"
                  size="small"
                  format="yyyy-MM-dd HH:mm:ss"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  default-time="23:59:59"
                  style="width: 152px; font-size: 12px"
                  class="time2"
                  :clearable="false"
                  :disabled="activityData.isStart"
                >
                </el-date-picker>
                <i class="el-icon-circle-close date_icon1" v-if="!activityData.isStart" @click="clearOrderTime()"></i>
                <img src="https://cdn-image.yucrm.cn/images/jd-front-platform/images/select_date.svg" alt="" class="date_icon2" />
              </div>
            </el-form-item>
            <el-form-item label="商品要求：" label-width="100px" required class="skuType-label">
              <el-radio v-model="taskForm.skuType" :label="0" :disabled="activityData.isStart">全部商品</el-radio>
              <el-radio v-model="taskForm.skuType" :label="1" :disabled="activityData.isStart">指定商品</el-radio>
              <el-radio v-model="taskForm.skuType" :label="2" :disabled="activityData.isStart">排除商品</el-radio>
              <div style="display: inline-block">
                <jd-button type="blue" @click="showGoods(100)" :disabled="taskForm.skuType == 0">选择商品（{{taskForm.skuIds.length}}/100）</jd-button>
              </div>
              <div class="tip-box">注:指定商品务必是预售商品，否则用户购买指定商品非预售商品将无法完成任务</div>
            </el-form-item>
            <!-- 指定商品规则：仅商品要求为"指定商品"时展示，0=整单计算 1=仅统计指定商品金额和件数 -->
            <el-form-item label="指定商品规则：" label-width="100px" v-if="taskForm.skuType == 1">
              <el-select style="width: 280px;" v-model="taskForm.statsSkuType" :disabled="activityData.isStart" placeholder="">
                <el-option label="只要订单包含指定商品就整单计算" :value="0"></el-option>
                <el-option label="仅统计订单内指定商品的金额和件数" :value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="任务条件:"  label-width="100px" required>
              <div v-for="(item,index) in taskOrderList" :key="index">
                <span>
                  每下单
                </span>
                <el-input placeholder="请输入" :disabled="activityData.isStart" v-model="item.limit" @change="(e)=>{item.limit = NumChange2(e,'limit',index)}" style="width: 95px; margin: 0 8px" @input="(e)=>{item.limit = inputValidateInputNew(e)}"/>
                <span>{{ taskForm.countType==2 ? "件商品" : "笔订单" }}获取</span>
                <el-input v-model.number="item.giveNum" :disabled="activityData.isStart" @change="(e)=>{item.giveNum = NumChange2(e,'giveNum',index)}" placeholder="请输入" style="width: 95px; margin-left: 8px" @input="item.giveNum = getNumberData(1, $event, 0, 1,999)"></el-input><span class="ml8">次抽奖机会</span>
              </div>
            </el-form-item>
            <el-form-item label="任务次数:" label-width="100px" required>
              <span class="mr8">活动期间最多获取</span>
              <el-input
                v-model.number="taskForm.condition2"
                placeholder="请输入"
                style="width: 95px"
                :disabled="activityData.isStart"
                @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
              ></el-input>
            <span class="ml8">次抽奖机会</span>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item label="任务条件:" v-if="taskForm.type != 17&&taskForm.type != 20" label-width="110px" required>
          <span v-if="taskForm.type == 13">
            成功浏览
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            件商品，赠送1次抽奖机会
          </span>
          <span v-else-if="taskForm.type == 4">
            成功加购
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            件商品，赠送1次抽奖机会
          </span>
          <span v-else-if="taskForm.type == 9">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次商品，赠送1次抽奖机会
          </span>
          <span v-else-if="taskForm.type == 10">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次店铺，赠送1次抽奖机会
          </span>
          <span v-else-if="taskForm.type == 11">
            成功分享
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次活动，赠送1次抽奖机会
          </span>
          <span v-else-if="taskForm.type == 12">
            每成功预约
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            件商品，赠送1次抽奖机会
          </span>
          <span v-else-if="taskForm.type == 16">
            每
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            积分可兑换1次机会
          </span>
          <span v-else-if="taskForm.type == 18">
            每成功邀请
            <el-input
              v-model.number="taskForm.condition"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition = getNumberData(1, $event, 0, 1)"
            ></el-input>
            个好友入会，赠送1次抽奖机会
          </span>
          <div v-else-if="taskForm.type == 5" class="flexc-cen-x">
            <span>每成功浏览当前链接</span>
            <el-input
              class="ml8"
              style="width: 100px"
              v-model="taskForm.viewTime"
              @input="taskForm.viewTime = getNumberData(1, $event, 0, 1)"
            ></el-input>
            <span class="ml8 mr8">秒，赠送</span>
            <el-input
              style="width: 100px"
              v-model="taskForm.giveLimit"
              @input="taskForm.giveLimit = getNumberData(1, $event, 0, 1)"
            ></el-input>
            <span class="ml8">次抽奖机会</span>
          </div>
          <span v-else>{{taskForm.condition}}</span>
        </el-form-item>
        <el-form-item label="搜索关键词:" v-if="taskForm.type == 23" label-width="110px" required>
          <el-input 
            style="width: 320px;" 
            v-model="taskForm.searchKeyword" 
            placeholder="请输入搜索关键词，例【橙汁】"
          ></el-input>
        </el-form-item>
        <el-form-item label="浏览商品:" label-width="110px" required v-if="taskForm.type == 13">
          <jd-button type="blue" @click="showGoods(100)">选择商品（{{taskForm.skuIds.length}}/100）</jd-button>
        </el-form-item>
        <el-form-item label="加购商品:" label-width="110px" required v-if="taskForm.type == 4">
          <jd-button type="blue" @click="showGoods(100)">选择商品（{{taskForm.skuIds.length}}/100）</jd-button>
        </el-form-item>
        <el-form-item label="分享商品:" label-width="110px" required v-if="taskForm.type == 9">
          <jd-button type="blue" @click="showGoods(1)">选择商品（{{taskForm.skuIds.length}}/1）</jd-button>
        </el-form-item>
        <el-form-item label="预约商品:" label-width="110px" required v-if="taskForm.type == 12">
          <div class="book-good-wrap">
            <jd-button type="blue" @click="showGoods(100)">选择商品（{{taskForm.skuIds.length}}/100）</jd-button>
            <span class="tip-red" style="margin-left:10px">注意：请添加预约商品，非预约商品无法完成任务</span>
          </div>
        </el-form-item>
        <el-form-item label="任务次数:" v-if="taskForm.type != 17&&taskForm.type != 20" label-width="110px" required>
          <span v-if="taskForm.type == 12">
            最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else-if="taskForm.type == 8">
            {{`活动期间内最多完成${taskForm.inviteLimit?taskForm.inviteLimit:0}次`}}
          </span>
          <span v-else-if="taskForm.type == 16">
            <el-select v-model="taskForm.activityType" placeholder="请选择">
              <el-option label="活动期间" :value="2"></el-option>
              <el-option label="每日" :value="1"></el-option>
            </el-select>
            最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else-if="taskForm.type == 18">
            活动期间最多完成
            <el-input
              v-model.number="taskForm.condition2"
              placeholder="请输入"
              style="width: 70px"
              @input="taskForm.condition2 = getNumberData(1, $event, 0, 1)"
            ></el-input>
            次
          </span>
          <span v-else>{{taskForm.count}}</span>
        </el-form-item>
        <el-form-item label="抽奖机会:" v-if="taskForm.type == 7" label-width="110px" required>
          <div>
            加入会员可获取<el-input v-model.number="taskForm.giveLimit" placeholder="请输入" style="width: 70px" @input="taskForm.giveLimit = getNumberData(1, $event, 0, 1,999)"></el-input>次抽奖机会
          </div>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <jd-button style="margin-right: 8px;" @click="taskClose">取消</jd-button>
        <jd-button v-if="!taskIsLook" type="blue" @click="sureTask">确定</jd-button>
      </div>
    </el-dialog>
    <!-- 选择商品弹窗 -->
    <select-goods v-if="goodsState" :skuSearch="true" :isLimit="true" :limitNum="goodsLimit" isInteract
      :isShow="goodsState" :moduleType="true" :selectGoods="selectGoodsSkuList"
      :hasSelectGoods="hasSelectGoods"
      :isClear="activityData.isStart"
      @close="selectGoodsChange" ></select-goods>
    <!-- 选择人群弹窗 -->
    <selectPeople v-if="selectPeopleShow" :dialogVisible="selectPeopleShow" :peopleList="peopleList" @confim="selectPeopleSure" @close="selectPeopleShow = false"></selectPeople>
    <!-- 增加奖品弹窗 -->
    <addPrizeNum :isShowAddNum="isShowAddNum" :prizeData="toAddItem" @confirm="confirmAdd" @close="isShowAddNum=false"/>
    <!-- 每日发放限额弹窗 -->
    <setLimitDialog
      :visible.sync="showLimitDialog"
      :init-data="limitData"
      :backgroundOpacity="backgroundOpacity"
      @confirm="handleLimitConfirm"
    />
  </div>
</template>

<script>
import SelectGoods from "@/components/selectGoodsMonitor2";
import selectPeople from "@/components/select-people-yunqi.vue";
import selectProduct from "./select_product_componentization.vue";
import QRCode from "qrcodejs2";
import { bigTurntableDraw, modifyBigTurn, getbigTurn, hdTaskTemplateGroup, sellerImage  } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/jhk/integralCenter/memberLevel";
import { updateCommon } from "@/api/jhk/integralCenter/integralTask";
import selectGoodsMonitor from "@/components/selectGoodsMonitor2.vue";
import draggable from "vuedraggable";

import { uploadpic } from "@/api/jhk/paradiseAndTaskCommonController.js";
import { getTaobaoItemListSku } from "@/api/jhk/analysis/ware-controller";
import addPrizeNum from "./components/add-prize-num.vue";
import setLimitDialog from '@/views/interactiveMarketing/activity/components/_components/setLimitDialog.vue'
import informationForm from "./components/informationForm.vue"
import exposureList from "./components/exposureList.vue"
import sharFrom from "./components/sharFrom.vue"
import activityRules from "./components/activityRules.vue"
import activityPageSettings from "./components/activityPageSettings.vue"
import { useValidateMultiShopGoods, useValidateMoreActSet } from "@/views/interactiveMarketing/activity/components/commDataHook/useBasicInformation.js";
import orderShopCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/orderShopCom.vue";
import productReqCom from "@/views/interactiveMarketing/activity/components/multipleStoreSetting/productReqCom.vue";
import customUpload from "./components/commCustomizationSet/customUpload.vue";
import customText from "./components/commCustomizationSet/customText.vue";
import btnSet from "./components/commCustomizationSet/btnSet.vue";
export default {
  components: {
    SelectGoods,
    selectProduct,
    selectGoodsMonitor,
    draggable,
    selectPeople,
    addPrizeNum,
    setLimitDialog,
    informationForm,
    exposureList,
    sharFrom,
    activityRules,
    activityPageSettings,
    orderShopCom,
    productReqCom,
    customUpload,
    customText,
    btnSet
  },
  props: {
    itemId: "",
    stepNum: {
      type: Number,
      default: 0,
    },
    activityData: {
      type: Object,
    },
    ids: {
      type: String,
      default: "",
    },
    isSave: {
      type: Boolean,
      default: true,
    },
    backgroundOpacity: {
      type: Boolean,
      default: false,
    },
    isDraftEdit: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    theNum(newName, oldName) {
      this.winningRate = 0;
      this.currentPrizeList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      this.winningRate = this.winningRate.toFixed(5);
    },
    localStepNum(newVal) {
      if (newVal == 0) {
        // this.$nextTick(() => {
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "1" }), queryId);
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "2" }), queryId2);
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "3" }), queryId3);
        //   this.qrcodeAll(this.telCode + "&templateJson=" + JSON.stringify({ templateUItype: "4" }), queryId4);
        // });
        this.$nextTick(() => {
          this.getCodeIMG();
        });
      } else {
        this.buriedPoint(1, this.activityData.name, "互动管理", "互动活动");
      }
    },
    // 监听 prizeSettingList 变化，自动同步到任务特定配置（除了中奖率）
    prizeSettingList: {
      handler(newVal, oldVal) {
        // 只有在任务特定配置存在时才进行同步
        if (Object.keys(this.taskPrizeConfigs).length > 0) {
          // 遍历所有任务类型的奖品配置
          for (const taskType in this.taskPrizeConfigs) {
            const taskPrizeList = this.taskPrizeConfigs[taskType];
            // 遍历通用奖品列表
            newVal.forEach((commonPrize, index) => {
              const correspondingTaskPrize = taskPrizeList.find(item => item.index === commonPrize.index);
              if (correspondingTaskPrize) {
                // 同步所有字段，除了 percentage 和 memberBuyPercentage
                for (const key in commonPrize) {
                  if (key !== 'percentage' && key !== 'memberBuyPercentage') {
                    this.$set(correspondingTaskPrize, key, commonPrize[key]);
                  }
                }
              }
            });
          }
        }
      },
      deep: true // 深度监听，确保能监听到对象内部属性的变化
    },
    permissions:{
      handler(nVal, oVal) {
        if (nVal.indexOf("hide:interactive:product:offline") != "-1") {
         this.isPremissionShow = false;
        }
      },
      immediate: true,
    },
    //自营和pop店铺其中一个或只有自营
    isVenderType(newVal) {
      if(newVal) {
        this.taskForm.orderPaymentType = 1
      } 
    },
    newGiftList: {
      handler(newVal, oldVal) {
        if(newVal.length>0){
          if(!this.ids) {
            if(this.ruleForm.luckyDrawForm!=1){
              this.currentSet(this.giftList[0])
            }
          } else {
            const obj = newVal.find(item => item.id == this.templateId)
            if(obj&&this.ruleForm.luckyDrawForm!=1) {
              // 兼容旧活动自定义字段没有参数
              this.defaultCustomSet(obj)
            }
          }
        }
      },
      immediate: true,
      deep: true,
    }
  },
  data() {
    return {
      currrentRgb:'',
      currentBlindBoxColor: "",
      currentSelectColor: "",
      currentBlindBoxBtnColor: "",
      currentFlipCardColor: "",
      currentFlipCardBtnColor: "",
      customerPaperwork: {
        title: "",
        desc: "",
        titleColor: "#000000",
        singleGridUrl:'',//单个宫格图
        drawBtnUrl:'',//抽奖按钮图
        selectColor:'',//选中色号
        noBlindBoxUrl:'',//单个盲盒图（未拆盒）图
        blindBoxUrl:'',//单个盲盒图（拆盒）图
        blindBoxText: "",//按钮文案
        blindBoxColor:'',//按钮字体颜色
        blindBoxBtnColor:'',//按钮背景颜色
        noSingleFlipCardUrl:'',//单个翻卡（未翻卡）图
        singleFlipCardUrl:'',//单个翻卡（已翻卡）图
        earnCountUrl:'',//赚次数图
        flipCardColor: "",//翻卡字体颜色
        flipCardBtnColor: "",//翻卡按钮背景颜色
        flipCardText: "",//翻卡按钮文案
        flipCardFontBold: false,//翻卡按钮字体是否加粗
      },
      multiShopGoods: [],
      hasSelectGoods: [],
      isSelectGoods: false,
      isPremissionShow: true,
      isForceRemind:false,
      isKeyActivity:0,
      placementPosition:[],

      cusTemplateJSON:'',

      taskIsLook:false,
      actEndTime: "",
      isShowTip: false,
      // 1.14迭代 指定入会时间
      ruleDto:{
        isCheckOpenCardTime:false,
        openCardStartTime:'',
        openCardEndTime:'',
        plusObject:0, //plus会员
      },
      openCardStartTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.ruleDTO.openCardEndTime).valueOf() - 24 * 60 * 60 * 1000;
        },
      },
      openCardEndTimeOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < new Date(this.ruleForm.ruleDTO.openCardStartTime).valueOf();
        },
      },

      actMember: "1",
      selectPeopleShow: false,
      peopleList: [],
      peopleSelected: [],
      isSelectProduct:false,
      mainImagelist: [],
      templateId: "",
      tabActive:0,
      navItem:{},
      pageData: {
        size: 10000,
        current: 1,
        total: 0,
      },
      giftList: [],
      oldGiftList: [],
      selectGoodsArr: [],
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      selectGoodsState: false, //曝光商品弹窗
      telCode: `https://yq-hd-rc.isvjcloud.com/clientPreview?venderId=${this.$store.state.loginUserInfo.venderId}&activityType=12`,
      // 不同抽奖形式对应的设计规范图
      luckyDrawDesignUrl: {
        // https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/xinyun.png
        1: "", // 大转盘
        2: "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/jgg.png", // 九宫格
        3: "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/mh.png", // 拆盲盒
        4: "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/fk.png", // 幸运翻卡
      },
      // 不同抽奖形式对应的模板下载地址
      luckyDrawTemplateUrl: {
        // https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/dzp.psd
        1: "", // 大转盘
        2: "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/dzp.psd", // 九宫格
        3: "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/dzp.psd", // 拆盲盒
        4: "https://cdn-image.yucrm.cn/images/yuqiyunzhou/activityPic/dzp.psd", // 幸运翻卡
      },
      tempSwitchList: [
        {
          isVisible: true,
          title: "全部",
          id: -1,
        },
      ],
      valueRow: null,
      echoDate: {},
      defaultTime: [this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length), this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)],
      pickerOptionsValue: {
        disabledDate: (time) => {
          if(this.ruleForm.endTime){
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.ruleForm.endTime).valueOf()
          }else{
            return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      pickerOptionsValueEnd: {
        disabledDate: (time) => {
          if(this.ruleForm.startTime){
            return time.getTime() < Date.now() - 8.64e7 || time.getTime() < new Date(this.ruleForm.startTime).valueOf()
          }else{
            return time.getTime() < Date.now() - 8.64e7
          }
        },
      },
      taskstartpickerOptionsValue: {
        disabledDate: (time) => {
          const endTime = this.taskForm.orderEndTime ? new Date(this.taskForm.orderEndTime).getTime() - 1 * 24 * 60 * 60 * 1000: null;
          const maxStartTime = endTime ? endTime - 90 * 24 * 60 * 60 * 1000 : null;
          return (
            (endTime && time.getTime() > endTime) ||
            (maxStartTime && time.getTime() < maxStartTime)
          );
        },
      },
      taskpickerOptionsValueEnd: {
        disabledDate: (time) => {
          const startTime = this.taskForm.orderStartTime ? new Date(this.taskForm.orderStartTime).getTime() + 1 * 24 * 60 * 60 * 1000 : null;
          const maxEndTime = startTime ? startTime + 89 * 24 * 60 * 60 * 1000 : null;
          return (
            (startTime && time.getTime() < startTime) ||
            (maxEndTime && time.getTime() > maxEndTime)
          );
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      qrcode: null,
      joinBlackList: false,
      checked: false,
      winningRate: 0,
      localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 15,
            message: "长度在 3 到 25 个字符",
            trigger: "blur",
          },
        ],
        partner: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个",
            trigger: "change",
          },
        ],
        term: [{ required: true, message: "请填写抽奖条件", trigger: "blur" }],
        isLongTime: [{ required: true, message: "请选择活动时间", trigger: "change" }],
        ruleDescription: [{ required: true, message: "请填写活动规则", trigger: "blur" }],
      },
      ruleForm: {
        firstOpenCardTimeType: 0, // 首次入会时间类型
        openCardBeforeDay: "", // 参与活动前N天
        openCardFollow: 0, // 开卡入会后方可参与活动
        ruleDTO:{
          plusObject: 0,
          openCardEndTime: '',
          isCheckOpenCardTime: false,
          openCardStartTime: '',
        },

        exposureSwitch: false,
        radio: 0,
        activityName: "",
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        partner: ["-1"],
        // 分享设置
        shareTitle: "",
        shareIntroduce: "",
        sharePic: "",
        type:1,

        goShopSetting:0, //进店设置
        goShopAppId: '',//小程序appId
        goShopUrl: '',//小程序页面路径
        luckyDrawForm: 1,
        isValidBlackList: 0,
        guaranteedWinPrizeFlag: 0,
      },
      raffleForm:{
        drawType:1,
        taskType:1,
        firstGiveTimes:null,
        everyDayGiveTimes:null,
        point: null,
        giveLimitType: 0,
      },
      taskDialog:false,
      taskTypeOptions:[
        {
          label:'每日签到',
          value:1,
          taskCondition:'成功签到，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'浏览店铺',
          value:2,
          taskCondition:'成功浏店铺，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'浏览商品',
          value:13,
          taskCondition:'成功浏览XX件商品，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'加购商品',
          value:4,
          taskCondition:'成功加购XX件商品，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'分享商品',
          value:9,
          taskCondition:'成功分享XX件商品，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'分享店铺',
          value:10,
          taskCondition:'成功分享XX次店铺，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'分享活动',
          value:11,
          taskCondition:'成功分享XX次活动，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'好友助力',
          value:8,
          taskCondition:'每邀请1位好友，赠送1次抽奖机会',
          taskCount:'活动期间最多最多完成XX次'
        },
        {
          label:'浏览会场',
          value:5,
          taskCondition:'成功浏览会场，赠送1次抽奖机会',
          taskCount:'活动期间每日最多完成1次'
        },
        {
          label:'预约商品',
          value:12,
          taskCondition:'每成功预约XX件商品，赠送1次抽奖机会，最多完成YY次',
          taskCount:'活动期间最多完成YY次'
        },
        {
          label:'积分兑换',
          value: 16,
          taskCondition:'每xx积分可兑换1次机会',
          taskCount:'活动期间最多完成YY次'
        },
        {
          label: "购买商品",
          value: 17,
          taskCondition: "完成任务赠送1次抽奖机会",
          taskCount: "活动期间最多完成1次",
        },
        {
          label: "邀请好友入会",
          value: 18,
          taskCondition: "成功邀请XX个好友入会，赠送1次抽奖机会",
          taskCount: "活动期间最多完成YY次",
        },
        {
          label: "加入会员",
          value: 7,
          taskCondition: "成功加入会员",
          taskCount: "活动期间最多完成1次",
        },
        {
          label: "预售下单",
          value: 20,
          taskCondition: "成功下单并支付定金，每满N件可赠送N次机会",
          taskCount: "活动期间最多获取N次抽奖机会",
        },
        {
          label: "搜索关键词",
          value: 23,
          taskCondition: "成功查询关键词，赠送1次抽奖机会",
          taskCount: "活动期间每日最多完成一次",
        },
      ],
      conditionValue:[13,4,9,10,11,12,16,17,18,20],
      goodsTypeList:[13,4,9,12],
      goodsLimitList:[13,4,12],
      rewardRulesOptions:[
        {
          value:0,
          label:'按固定次数赠送抽奖机会'
        },
        {
          value:1,
          label:'按倍数赠送抽奖机会'
        },
        {
          value:2,
          label:'按阶梯赠送抽奖机会'
        },
      ],
      taskLevelList:[],
      taskOrderList:[],
      taskForm:{
        // 1.29迭代参数
        giveType:0,
        countType:1,
        taskDoType:0,

        type:1,
        taskTime:1,
        condition:null,
        condition2:null,
        count:null,
        endTime:null,
        startTime:null,
        skuIds:[],
        inviteLimit:null,
        jumpUrl:null,
        selectGoodsSkuList:[],
        venderIds:[],
        sellerSkuList: [],
        cancelOrderInvalid: 0,
        orderPaymentType: 1,
        mergeOrder: false
      },
      isTaskEdit:false,
      taskRow:{},
      taskDataList:[],
      sharePic: "",
      bigTurntable: {
        oneDayMaxDrawNumber: null,
        totalMaxDrawNumber: null,
        oneDayMaxRewardNumber: null,
        totalMaxRewardNumber: null,
      },
      bigTurntableDrawS: [
        // {
        //   assetsId: 0,
        //   logo: "string",
        //   giftType: 0,
        //   logo: "string",
        //   percentage: 0,
        //   price: 0,
        //   prizeType: 0,
        //   singleAmount: 0,
        //   title: "string",
        //   totalAmount: 0,
        // },
      ],
      activityStartTime: null,
      activityEndTime: null,
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
      ],
      copyPrizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
      ],
      prizeSettingListOld: [],
      index: 0,
      theNum: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      fileList: "",
      disableTime: false,

      templateJson: {
        templateUItype: "",
      },

      levelList: [],
      itemArr: [],
      goodsState:false,
      goodsLimit:100,
      selectGoodsSkuList:[],
      isDraft:false,
      toAddItem: null,
      isShowAddNum: false,
      toAddBelong: '',
      toAddIndex: 0,
      showLimitDialog: false, // 每日发放限额弹窗
      limitData: {}, // 初始数据
      // 概率配置类型：0-固定概率，1-按任务配置
      probabilityType: 0,
      probabilityConfigOptions: [
        {
          value: 0,
          label: '固定概率'
        },
        {
          value: 1,
          label: '按任务配置'
        }
      ],
      activeProbabilityTab: 'common', // 当前激活的tab
      selectedTaskTypes: [], // 选中的任务类型列表
      taskPrizeConfigs: {}, // 格式: { 1: [...], 2: [...] }
    };
  },
  computed: {
    venderType() {
      // 是否为自营店铺
      return this.$store.getters.loginUserInfo.venderType;
    },
    // 翻卡按钮文案动态字数上限：纯中文7、纯英文15、中英混合10、空文本初始7
    flipCardTextMaxLength() {
      const text = this.customerPaperwork.flipCardText || '';
      const hasChinese = /[\u4e00-\u9fa5]/.test(text);
      const hasEnglish = /[a-zA-Z]/.test(text);
      if (hasChinese && hasEnglish) return 10;
      if (hasEnglish) return 15;
      return 7;
    },
    // 获取任务类型
    getTaskType(){
      return (type)=>{
        const obj = this.taskTypeOptions.find(item=>item.value == type)
        return obj.label
      }
    },
    // 获取任务条件
    getCondition(){
      return (item)=>{
        const {type,condition,condition2, orderCountType} = item
        let str = condition
        if(type == 13){
          str = `成功浏览${condition}件商品，赠送1次抽奖机会`
        }else if(type == 4){
          str = `成功加购${condition}件商品，赠送1次抽奖机会`
        }else if(type == 9){
          str = `成功分享${condition}次商品，赠送1次抽奖机会`
        }else if(type == 10){
          str = `成功分享${condition}次店铺，赠送1次抽奖机会`
        }else if(type == 11){
          str = `成功分享${condition}次活动，赠送1次抽奖机会`
        }else if(type == 12){
          str = `每成功预约${condition}件商品，赠送1次抽奖机会`
        }else if(type == 16){
          str = `每${condition}积分可兑换1次机会`
        }else if(type == 17){
          if(item.giveType == 0){
            str = orderCountType == 0 ? `每1个订单赠送1次抽奖机会`: `完成任务赠送1次抽奖机会`
          }else if(item.giveType == 1){
            this.taskLevelList.forEach(it=>{
              str = `购买商品，每满${item.countType == 1?it.limit+'元':item.countType == 2?it.limit+'件':item.countType == 3?it.limit+'笔':''}可赠送${it.giveNum}次抽奖机会`
            })
          }else if(item.giveType == 2){
            str = `购买商品：`
            this.taskLevelList.forEach(it=>{
              str = str +`\n满${item.countType == 1?it.limit+'元':item.countType == 2?it.limit+'件':item.countType == 3?it.limit+'笔':''}可赠送${it.giveNum}次抽奖机会；`
            })
          }
        }else if(type == 18){
          str = `成功邀请好友入会${condition}次，赠送1次抽奖机会`
        } else if(type == 20){
          this.taskOrderList.forEach(it=>{
            str = `成功下单并支付定金，每满${item.countType == 2 ? it.limit+'件' : it.limit+'笔'}可赠送${it.giveNum}次机会`
          })
        } else if(type == 5){
          str = `成功浏览会场${item.viewTime || 1}秒，可赠送${item.giveLimit || 1}次机会`
        }else if (type == 23) {
            str = `成功查询关键词，赠送1次机会`;
          }
        return str
      }
    },
    // 获取任务次数
    getCount(){
      return (item)=>{
        const {type,count,inviteLimit,condition2,activityType,orderCountType} = item
        let str = count
        if(type == 12){
          str = `活动期间最多完成${condition2}次`
        }else if(type == 8){
          str = `活动期间最多完成${inviteLimit}次`
        }else if(type == 16){
          str = `${activityType == 2 ? '活动期间' : '活动期间每日'}最多完成${condition2}次`
        }else if(type == 17&&item.giveType == 0) {
          str = `活动期间最多完成${orderCountType == 0 ? condition2 : '1'}次`
        }else if(type == 17&&item.giveType != 0) {
          str = item.taskDoType == 0?'活动期间不限次数':`活动期间最多获得${item.condition2}次抽奖机会`
        }else if(type == 18){
          str = `活动期间最多完成${condition2}次`
        }else if(type == 20){
          str = `活动期间最多获取${condition2}次抽奖机会`
        }
        return str
      }
    },
    // 可选择的任务列表（基于taskDataList）
    availableTaskOptions() {
      return this.taskDataList.map(task => {
        const taskType = this.taskTypeOptions.find(option => option.value === task.type);
        return {
          value: task.type,
          label: taskType.label
        };
      });
    },
    // 动态生成的概率配置tab列表
    dynamicProbabilityTabs() {
      const tabs = [{
        name: 'common',
        label: '通用概率'
      }];
      // 根据选中的任务类型添加tab
      this.selectedTaskTypes.forEach(taskType => {
        const taskOption = this.taskTypeOptions.find(option => option.value === taskType);
        if (taskOption) {
          tabs.push({
            name: `${taskType}`,
            label: taskOption.label
          });
        }
      });
      return tabs;
    },
    // 当前显示的奖品列表（根据选中的tab）
    currentPrizeList() {
      if (this.activeProbabilityTab === 'common') {
        return this.prizeSettingList;
      } else {
        // 如果是任务tab，返回对应任务的奖品配置
        console.log(this.activeProbabilityTab,this.taskPrizeConfigs,'vvvvvv');
        if (!this.taskPrizeConfigs[this.activeProbabilityTab]) {
          // 如果该任务还没有配置，复制通用配置
          this.$set(this.taskPrizeConfigs, this.activeProbabilityTab,
            JSON.parse(JSON.stringify(this.prizeSettingList))
          );
        }
        return this.taskPrizeConfigs[this.activeProbabilityTab];
      }
    },
    // 判断当前是否为任务tab
    isTaskTab() {
      return this.activeProbabilityTab !== 'common';
    },
    // 判断是否有草稿箱按钮
    hasDraftBtn(){
      return this.isDraftEdit || !this.valueRow || this.activityData.isCopy;
    },
    // 1: 京获客旗舰版
    softType() {
      return this.$store.getters.loginUserInfo.yunZhouOtherType || '';
    },
    //权限判断
    permissions() {
      return this.$store.getters.loginUserInfo.permissions;
    },
    widthNumber() {
      return this.ruleForm.luckyDrawForm !=1 ? 750 : 0
    },
    heightNumber() {
      return this.ruleForm.luckyDrawForm !=1 ? 1650 : 0
    },
    venderId() {
      return this.$store.getters.loginUserInfo.venderId || '';
    },
    isVenderType() {
      return this.multiShopGoods.some((item) => item.venderType);
    },
    newGiftList() {
      let list = []
      if(this.ruleForm.luckyDrawForm==1){
        list= this.oldGiftList.filter(item => item.layout == 1 || item.layout==3)
      }else if(this.ruleForm.luckyDrawForm==2){
        list = this.oldGiftList.filter(item => item.layout == 2)
      }else if(this.ruleForm.luckyDrawForm==3){
        list = this.oldGiftList.filter(item => item.layout == 4)
      }else if(this.ruleForm.luckyDrawForm==4){
        list = this.oldGiftList.filter(item => item.layout == 5)
      }
      return list
    }
  },
  created(){
    console.log('当前玩法id',this.activityData.id);
    this.sharePic = this.getDefaultSharePic(this.activityData.id)
    this.ruleForm.sharePic = this.sharePic
    this.ruleForm.shareTitle = `我分享了一个${this.activityData.name}活动给你，快来看看吧！`
    this.ruleForm.shareIntroduce = `我在京东有新发现，绝对适合你，速来围观～`
  },
  mounted() {
    this.prizeSettingListOld = this.prizeSettingList
    this.getLevel();
    this.getDetail();
    console.log("当前玩法Data",this.activityData);
  },

  methods: {
    viewMergeLogic() {
       window.open("https://www.yuque.com/yunduanxincrm/mrkpcq/mub1q6wafxefavp4?singleDoc#");
    },
    // 翻卡按钮文案输入校验：跨越规则（如英文转混合）时按当前规则截断
    handleFlipCardTextInput(value) {
      const max = this.flipCardTextMaxLength;
      if (value && value.length > max) {
        this.customerPaperwork.flipCardText = value.slice(0, max);
      }
    },
    getPrizeSet() {
      return [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        }
      ]
    },
    handleChangeOrderCountType() {
      this.taskForm.countType = 1
      this.taskForm.cancelOrderInvalid = 0;
    },
    handleChangeOrderType() {
      this.taskForm.cancelOrderInvalid = 0;
    },
    initData() {
      this.taskForm.venderIds = this.taskForm.venderIds&&this.taskForm.venderIds.length> 0 ? this.taskForm.venderIds : [this.venderId];
      this.taskForm.sellerSkuList = this.taskForm.sellerSkuList&&this.taskForm.sellerSkuList.length> 0 ? this.taskForm.sellerSkuList : [
        {
          venderId: this.venderId,
          skuIds: [],
          itemList: [],
        },
      ];
      this.multiShopGoods = useValidateMultiShopGoods(this, this.taskForm.venderIds);
    },
    showSharePic(){
      if(this.ruleForm.luckyDrawForm == 3){
          this.sharePic = 'https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/shareBlindBox.svg'
        }else if(this.ruleForm.luckyDrawForm == 4){
          this.sharePic = 'https://cdn-image.yucrm.cn/images/jd-front-platform/images/integralCenter/shareLuckyCard.svg'
        }else{
          this.sharePic = this.getDefaultSharePic(this.activityData.id)
        }
        this.ruleForm.sharePic = this.sharePic
    },
    defaultCustomSet(obj) {
      if(this.ruleForm.luckyDrawForm==2){
        // 判断该对象是否有selectColor属性
        if(!("selectColor" in this.customerPaperwork)) {
          this.$set(this.customerPaperwork, 'selectColor', obj.rgb);
        } 
        this.currentSelectColor = obj.rgb;
      }else if(this.ruleForm.luckyDrawForm==3){
        // 判断该对象是否有blindBoxColor属性
        if(!("blindBoxColor" in this.customerPaperwork)) {
          this.$set(this.customerPaperwork, 'blindBoxColor', obj.rgb);
        }
        this.currentBlindBoxColor = obj.rgb
        if(!("blindBoxBtnColor" in this.customerPaperwork)) {
          this.$set(this.customerPaperwork, 'blindBoxBtnColor', obj.rgb2);
        }
        this.currentBlindBoxBtnColor = obj.rgb2
        if(obj.configJson){
          // 判断该对象是否有blindBoxText属性
          if(!("blindBoxText" in this.customerPaperwork)) {
            this.$set(this.customerPaperwork, 'blindBoxText', JSON.parse(obj.configJson).btnContent);
          }
        }
      }else if(this.ruleForm.luckyDrawForm==4){
        // 判断该对象是否有titleColor属性
        const rgb = this.normalizeColor(obj.rgb);
        const rgb2 = this.normalizeColor(obj.rgb2);
        const rgb3 = this.normalizeColor(obj.rgb3) || "#000000";
        if(!("titleColor" in this.customerPaperwork)) {
          this.$set(this.customerPaperwork, 'titleColor', rgb3);
        }
        this.currrentRgb = rgb3;
        this.currentFlipCardColor = rgb;
        this.currentFlipCardBtnColor = rgb2;
        if(!("flipCardColor" in this.customerPaperwork)) {
          this.$set(this.customerPaperwork, 'flipCardColor', obj.rgb);
        }
        if(!("flipCardBtnColor" in this.customerPaperwork)) {
          this.$set(this.customerPaperwork, 'flipCardBtnColor', obj.rgb2);
        }
        if(obj.configJson){
          const configJson = JSON.parse(obj.configJson);
          // 判断该对象是否有title属性
          if(!("title" in this.customerPaperwork)) {
            this.$set(this.customerPaperwork, 'title', configJson.activeName);
          }
          // 判断该对象是否有desc属性
          if(!("desc" in this.customerPaperwork)) {
            this.$set(this.customerPaperwork, 'desc', configJson.activeDesc);
          }
          if(!("flipCardText" in this.customerPaperwork)) {
            this.$set(this.customerPaperwork, 'flipCardText', configJson.btnContent);
          }
        }
      }
    },
    currentSet(obj) {
      if(this.ruleForm.luckyDrawForm==2){
        this.customerPaperwork.selectColor = obj.rgb;
        this.currentSelectColor = obj.rgb;
      }else if(this.ruleForm.luckyDrawForm==3){
        this.customerPaperwork.blindBoxColor = obj.rgb;
        this.currentBlindBoxColor = obj.rgb;
        this.customerPaperwork.blindBoxBtnColor = obj.rgb2;
        this.currentBlindBoxBtnColor = obj.rgb2;
        if(obj.configJson){
          this.customerPaperwork.blindBoxText = JSON.parse(obj.configJson).btnContent;
        }
      }else if(this.ruleForm.luckyDrawForm==4){
        const rgb = this.normalizeColor(obj.rgb);
        const rgb2 = this.normalizeColor(obj.rgb2);
        const rgb3 = this.normalizeColor(obj.rgb3) || "#000000";
        this.customerPaperwork.flipCardColor = rgb;
        this.customerPaperwork.flipCardBtnColor = rgb2;
        this.customerPaperwork.titleColor = rgb3;
        this.currrentRgb = rgb3;
        this.currentFlipCardColor = rgb;
        this.currentFlipCardBtnColor = rgb2;
        if(obj.configJson){
          const configJson = JSON.parse(obj.configJson);
          this.customerPaperwork.title = configJson.activeName;
          this.customerPaperwork.desc = configJson.activeDesc;
          this.customerPaperwork.flipCardText = configJson.btnContent;
        }
      }
    },
    normalizeColor(color) {
      if (!color) return color;
      if (typeof color !== 'string') return color;
      const trimmed = color.trim();
      if (/^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(trimmed)) {
        return trimmed.toLowerCase();
      }
      const rgbMatch = trimmed.match(/^rgba?\(([^)]+)\)$/i);
      if (rgbMatch) {
        const parts = rgbMatch[1].split(',').map((s) => s.trim());
        const toHex = (n) => {
          const num = Math.max(0, Math.min(255, Math.round(parseFloat(n))));
          return num.toString(16).padStart(2, '0');
        };
        return `#${toHex(parts[0])}${toHex(parts[1])}${toHex(parts[2])}`;
      }
      const ctx = document.createElement('canvas').getContext('2d');
      ctx.fillStyle = '#000000';
      ctx.fillStyle = trimmed;
      const hex = ctx.fillStyle;
      if (/^#[0-9a-f]{6}$/i.test(hex)) {
        return hex.toLowerCase();
      }
      return trimmed;
    },
    getGiftList(){
      if(this.ruleForm.luckyDrawForm==1){
        this.giftList = this.oldGiftList.filter(item => item.layout == 1 || item.layout==3)
      }else if(this.ruleForm.luckyDrawForm==2){
        this.giftList = this.oldGiftList.filter(item => item.layout == 2)
      }else if(this.ruleForm.luckyDrawForm==3){
        this.giftList = this.oldGiftList.filter(item => item.layout == 4)
      }else if(this.ruleForm.luckyDrawForm==4){
        this.giftList = this.oldGiftList.filter(item => item.layout == 5)
      }
      if(!this.ids) {
        if(this.ruleForm.luckyDrawForm!=1&&this.giftList.length>0){
          this.currentSet(this.giftList[0])
        }
      } else {
        const obj = this.giftList.find(item => item.id == this.templateId)
        if(obj&&this.ruleForm.luckyDrawForm!=1) {
          // 兼容旧活动自定义字段没有参数
          this.defaultCustomSet(obj)
        } else {
          this.currentSet(this.giftList[0])
        }
      }
    },
    changeLayout(e){
      this.showSharePic()
      if(e==4){
        this.prizeSettingList = this.prizeSettingListOld.slice(0,6)
      }else if(e==3){
        let obj ={
          index: 8,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          dailyLimitType: 0,
          percentage: null,
          memberBuyPercentage: null,
        }
        this.prizeSettingList = [...this.prizeSettingListOld,obj]
      }else{
        this.prizeSettingList = this.prizeSettingListOld
      }
      this.ruleForm.luckyDrawForm = e
      if(this.giftList.length>0){
        this.templateId = this.newGiftList[0].id
        this.templateJson.templateUItype = 0;
      }else {
        this.templateId = ''
        this.templateJson.templateUItype = 0;
      }
      const obj = this.newGiftList.find(item => item.id == this.templateId)
      this.currentSet(obj)
    },
    handleInputPrice(value) {
      // 过滤非数字和非小数点字符
      let filteredValue = value.replace(/[^0-9.]/g, "");

      // 确保只保留第一个小数点
      const firstDotIndex = filteredValue.indexOf(".");
      if (firstDotIndex !== -1) {
        const beforeDot = filteredValue.slice(0, firstDotIndex + 1);
        const afterDot = filteredValue
          .slice(firstDotIndex + 1)
          .replace(/\./g, "");
        filteredValue = beforeDot + afterDot;
      }

      // 处理整数部分前导零
      if (firstDotIndex === -1) {
        // 非小数，若数字不为 0，移除前导零
        if (filteredValue !== "0") {
          filteredValue = filteredValue.replace(/^0+/, "");
        }
      } else {
        const integerPart = filteredValue.slice(0, firstDotIndex);
        const decimalPart = filteredValue.slice(firstDotIndex);
        // 若整数部分非空且以多个 0 开头，只保留一个 0
        const cleanedIntegerPart = integerPart.replace(/^0+(?=\d)/, "");
        filteredValue = cleanedIntegerPart + decimalPart;
      }

      // 确保小数点不在开头
      filteredValue = filteredValue.replace(/^\./, "0.");

      // 确保只保留三位小数
      if (firstDotIndex !== -1) {
        const decimalPart = filteredValue.slice(firstDotIndex + 1);
        filteredValue =
          filteredValue.slice(0, firstDotIndex + 1) + decimalPart.slice(0, 3);
      }

      return filteredValue;
    },
    selectTemplate(index,id){
      this.templateId = id
      this.templateJson.templateUItype = index;
      const obj = this.newGiftList.find(item => item.id == this.templateId)
      if(this.ruleForm.luckyDrawForm!=1&&obj){
        this.currentSet(obj)
      }
    },
    countTypeChange(){
      this.taskLevelList.forEach(item=>{
        item.limit = ''
      })
    },
    handleCountTypeChange(){
      this.taskOrderList.forEach(item=>{
        item.limit = ''
      })
    },
    NumChange(e,key,valueIndex){
      let res = e
      this.taskLevelList.forEach((item,index)=>{
        if(valueIndex>index){
          if(parseFloat(res)<=parseFloat(item[key])){
            res = ''
          }
        }
      })
      return res
    },
    NumChange2(e,key,valueIndex){
      let res = e
      this.taskOrderList.forEach((item,index)=>{
        if(valueIndex>index){
          if(parseFloat(res)<=parseFloat(item[key])){
            res = ''
          }
        }
      })
      return res
    },
    giveTypeChange(e){
      this.taskForm.cancelOrderInvalid = 0;
      if(e == 1){
        this.taskLevelList = [
          {
            taskIndex:1,
            limit:'',
            giveNum:'',
          },
        ]
      }
      if(e == 2){
        this.taskLevelList = [
          {
            taskIndex:1,
            limit:'',
            giveNum:'',
          },
          {
            taskIndex:2,
            limit:'',
            giveNum:'',
          },
        ]
      }
    },
    addTaskLevel(){
      let postData = {
        taskIndex:1,
        limit:'',
        giveNum:'',
      }
      postData.taskIndex = this.taskLevelList.length + 1
      this.taskLevelList.push(postData)
    },
    delTaskLevel(index){
      this.taskLevelList.splice(index,1)
    },
    // 点击下单时间显示提示
    orderFocus() {
      if(this.activityData.isStart) {
        this.isShowTip = true
      }
    },
    // 改变数量值
    confirmAdd(num) {
      let {toAddBelong, toAddIndex} = this;
      this[toAddBelong][toAddIndex].totalAmount = num;
      this.isShowAddNum = false;
    },
    // 获取相关数据打开弹窗
    itemAddNum(arrStr,index) {
      this.toAddItem = {
        ...this[arrStr][index],
        num: this[arrStr][index].totalAmount
      };
      if( !this.toAddItem.title || this.toAddItem.title=="谢谢参与" ) {
        this.$message.error("没有奖品不能设置数量！")
        return
      }
      this.toAddBelong = arrStr;
      this.toAddIndex = index;
      this.isShowAddNum = true;
    },
    onShopSetChange(value) {
      this.ruleForm.goShopAppId = '';
      this.ruleForm.goShopUrl = '';
    },
    // 1.14迭代
    clearNewTime() {
      this.ruleForm.ruleDTO.openCardStartTime = "";
      this.ruleForm.ruleDTO.openCardEndTime = "";
    },

    // 打开选择人群
    openCrowd(){
      this.peopleList = this.peopleSelected.map(item => {
        return { id: item }
      })
      this.selectPeopleShow = true
      this.actMember = "3"
    },
    // 选择人群关闭
    selectPeopleSure(val){
      this.peopleSelected = val.map(item=>item.id)
      this.selectPeopleShow = false
    },
    inp(val){
      this.$forceUpdate()
    },
    // 京东计划数量计算
    prizeNum(row){
      console.log(row);
      // 京豆计划已在其他函数判断，这里只计算 京东E卡、plus、爱奇艺、红包
      if([5,6,7,8,10].includes(Number(row.prizeType))){
        if(Number(row.totalAmount) && (Number(row.totalAmount) > row.budgetRemain)){
          row.totalAmount = ""
          if(row.prizeType == 5) this.$message.error("京东E卡总份额数量不能大于该京东E卡剩余预算额！")
          if(row.prizeType == 6) this.$message.error("爱奇艺会员总份额数量不能大于该爱奇艺会员剩余预算额！")
          if(row.prizeType == 7) this.$message.error("京东PLUS会员总份额数量不能大于该京东PLUS会员剩余预算额！")
          if(row.prizeType == 8) this.$message.error("现金红包总份额数量不能大于该现金红包剩余预算额！")
          if(row.prizeType == 10) this.$message.error("礼品卡总份额数量不能大于该礼品卡剩余预算额！")
        }
      }
    },
    // 活动进行中修改奖品数量
    beAdd(row){
      if(this.activityData.isStart){
        if(row.totalAmount < row.minNum && row.minNum){
          row.totalAmount = row.minNum
          this.$message.error("为避免客诉，奖品数量不能小于之前哦~")
        }
      }
    },
    //上传图片前校验   分享设置
    beforeUpload1(file) {
      let _this = this
      let image = new Image()
      let _URL = window.URL || window.webkitURL
      image.onload = function () {
        const valid = (image.width == 200 && image.height == 200)
        file.isFlag = valid
        _this.uploadSize = valid
        console.log(valid);
        if(valid){
        }else{
          _this.$message.info('图片宽高不符合要求,请重新上传')
          sizetype = false
          return false
        }
      }
      image.src = _URL.createObjectURL(file)
      console.log(file);
      const isLt3M = file.size < 1024 * 1024;
      
      let type = file.name.substring(file.name.lastIndexOf(".")).toLowerCase();
      let sorts = [".png", ".jpg"]
      let sizetype = false
      if (!isLt3M) {
        this.$message.info("上传图片大小不能超过 1MB");
        return false
      }
      if (sorts.indexOf(type) < 0) {
        this.$message.info("所选文件格式不符，请重新选择");
        return false;
      }
    },
    // 上传成功  分享设置
    handleUpload1(res){
      if(res.code != 1){
        this.$message.error(res.message);
      }else{
        console.log(this.uploadSize);
        if(this.uploadSize){
          this.ruleForm.sharePic = res.data;
          this.$forceUpdate()
          // console.log(this.ruleForm.sharePic);
        }
      }
    },
    // 重置背景图  分享设置
    picUrlReset1(){
      this.ruleForm.sharePic = this.sharePic
      this.$forceUpdate()
    },
    getDaysBetween(dateString1, dateString2) {
      const startDate = Date.parse(dateString1);
      const nowDate =  Date.parse(new Date());
      // console.log(nowDate,startDate);
      const endDate = Date.parse(dateString2);
      if (startDate > endDate) {
        return 0;
      }
      if (startDate == endDate) {
        return 1;
      }
      let days = 0;
      if(nowDate > startDate){
        days = (endDate - nowDate) / (1 * 24 * 60 * 60 * 1000);
      }else{
        days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
      }
      // console.log(days);
      
      return Math.floor(days) == 0 ? "1天" : Math.ceil(days) + "天";
    },

    handleNav(item,index){
      this.tabActive = index;
      this.navItem = item;
      this.getPolite()
    },

    // 模板类型
    async hdTaskTemplateGroup() {
      const { data } = await hdTaskTemplateGroup({
        hdTaskType: this.activityData.id,
      });
      this.tempSwitchList = [
        {
          id: -1,
          groupName: "全部",
          frontHide: false,
        },
        ...data,
      ];
      this.tempSwitchList.map((item) => {
        item.isVisible = true
        item.title = item.groupName
      })
      this.getPolite()
    },

    // 活动模板
    async getPolite() {
      let params = {
        current: this.pageData.current,
        size: this.pageData.size,
        templateGroupId: this.navItem.id == -1 ? "" : this.navItem.id,
        source: 4,
        hdTaskType: this.activityData.id,
      };
      const { data } = await sellerImage(params);
      this.giftList = data.records.map((item) => {
        return {
          ...item,
          days: item.activityStartTime
            ? this.getDaysBetween(item.activityStartTime, item.activityEndTime)
            : "",
        };
      });
      this.oldGiftList = this.giftList
      // this.getGiftList()
      if(!this.templateId){
        this.templateId = this.giftList[0].id
        // this.localStepNum = 1;
        this.templateJson.templateUItype = 0;
      }
      this.pageData.total = data.total * 1;
      this.$nextTick(() => {
        this.getCodeIMG();
      });
    },

     //删除
    delec(index) {
      this.mainImagelist.splice(index, 1);
      this.itemListFor.splice(index, 1);
      // console.log(this.selectGoodsArr, 4444444);
    },

    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        this.draggingId = arr;
      });
    },

    selectGoodsClose(data) {
      console.log(data, 222);
      if (data) {
        console.log(data);
        this.itemListFor = [];
        this.mainImagelist = [];
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListFor.push(fomeVaule);
          this.mainImagelist.push(fomeVaule);
        });
        console.log(this.mainImagelist);
        this.selectGoodsArr = this.itemListFor;
      }
      // console.log(this.selectGoodsArr, this.itemListFor, 3333);
      this.selectGoodsState = false;
    },

    //添加曝光商品弹窗
    exposureProducts() {
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$refs.selectGo.handleRightCurrentChange(1);
    },

    exposureSwitchChange(val) {
      if (!val) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      this.$forceUpdate()
    },

    nextStepKai(index, templateId = 0) {
      this.localStepNum = 1;
      this.templateJson.templateUItype = index;
      if(templateId) {
        this.templateId = templateId
      }
    },
    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
        })
        .catch((res) => {});
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    getCodeIMG() {
      const codeImg = document.querySelectorAll(".qrCodeIMG");
      for (let index = 0; index < codeImg.length; index++) {
        const elementbox = codeImg[index];
        elementbox.innerHTML = "";
      }
      let url = this.activityData.id == 14 ? "http://yq-hd-rc.isvjcloud.com/shop.html" :"http://index.yeionsms.com/yidongd/index.html"
      const arr = [1, 8, 16, 17, 18, 19, 27, 28]
      if(arr.includes(Number(this.activityData.id))) {
        url = "https://yq-hd-rc.isvjcloud.com/templateCommon?templateImg="
      }
      // const codeImg = this.$refs[queryIdIMG];
      for (let index = 0; index < codeImg.length; index++) {
        const element = codeImg[index];
        new QRCode(element, {
          width: 140, // 设置宽度，单位像素
          height: 140, // 设置高度，单位像素
          // text: url, // 设置二维码内容或跳转地址
          text: this.activityData.id == 13 ? `${url}?image=${this.giftList[index].templateUrl}` : arr.includes(Number(this.activityData.id)) ? `${url}${this.giftList[index].secondImageUrl}` : `${url}?image=${this.giftList[index].templateExampleUrl}`
        });
      }
    },
    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 140, // 设置宽度，单位像素
        height: 140, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // 不能输入0，绑定的值如果小于1，那么输入框置空
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (row.quantityTotal && row.price && row.totalAmount && row.prizeType == 2) {
          let numTotal = this.$jingdouTotal({ ...row, prizeCount: row.totalAmount });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    checkLimit(row,min) {
      let newVal = (row.dailyLimit+ "").replace(/[^\d]/g, '')
      if(newVal) {
        if(newVal<min) {
          return ""
        }else {
          if(Number(row.dailyLimit) > Number(row.totalAmount)) {
            this.$message.warning("每日发放限额需小于等于奖品数量，请重新输入");
            return ""
          } else {
            return Number(row.dailyLimit)
          }
        }
      }
    },
    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else {
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.fileList = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      // this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    // changeImg(row) {
    //   console.log(row, 33333333333);
    // },
    httpRequest() {},
    //生成规则
    generateRule() {
      let text1 = "",
        text5 = "",
        secondText = "\n二、【如何参与】",
        thirdText = "\n四、【注意事项】";
        const {firstText,precautions} = this.getCommonText(this.levelList,this.ruleForm,this.ruleForm.ruleDTO,this.actMember)
      if (this.raffleForm.drawType == 1) {
        text1 = "参与方式：按要求完成“指定任务”后可获得抽奖机会，在活动期间进入活动手动抽取奖品；";
        text5 = `抽奖条件：`
        let count = 0
        if(this.raffleForm.taskType == 2){
          count += 1
          text5 += `\n（1）每人每天赠送抽奖机会${this.raffleForm.everyDayGiveTimes || 0}次`
        }else if(this.raffleForm.taskType == 1){
          count += 1
          text5 += `\n（1）每人首次赠送${this.raffleForm.firstGiveTimes || 0}次`
        }
        this.taskDataList.forEach(list=>{
          const str = this.getCondition(list).replace(/\n/g,'')
          const str2 = this.getCount(list)
          text5 += `\n（${++count}）${str}，${str2}`
        })
      }else{
        text1 = "消耗积分可获得抽奖机会，在活动期间进入活动手动抽取奖品；";
        if(this.raffleForm.point){
          text5 = "抽奖条件：用户消耗" + this.raffleForm.point + "积分抽奖一次";
        }
      }
      // if (this.bigTurntable.oneDayMaxDrawNumber && this.bigTurntable.totalMaxDrawNumber) {
      //   if (this.bigTurntable.oneDayMaxRewardNumber && this.bigTurntable.totalMaxRewardNumber) {
      //     text6 =
      //       "抽奖和中奖限制：每人每天最多抽奖次数" +
      //       this.bigTurntable.oneDayMaxDrawNumber +
      //       "次，活动期间累计抽奖最多" +
      //       this.bigTurntable.totalMaxDrawNumber +
      //       "次，活动期间每人每天中奖不超过" +
      //       this.bigTurntable.oneDayMaxRewardNumber +
      //       "次, 累计中奖不超过" +
      //       this.bigTurntable.totalMaxRewardNumber +
      //       "次";
      //   } else if (this.bigTurntable.oneDayMaxRewardNumber) {
      //     text6 =
      //       "抽奖和中奖限制：每人每天最多抽奖次数" +
      //       this.bigTurntable.oneDayMaxDrawNumber +
      //       "次，活动期间累计抽奖最多" +
      //       this.bigTurntable.totalMaxDrawNumber +
      //       "次，活动期间每人每天中奖不超过" +
      //       this.bigTurntable.oneDayMaxRewardNumber +
      //       "次, 累计中奖不限次";
      //   } else if (this.bigTurntable.totalMaxRewardNumber) {
      //     text6 =
      //       "抽奖和中奖限制：每人每天最多抽奖次数" +
      //       this.bigTurntable.oneDayMaxDrawNumber +
      //       "次，活动期间累计抽奖最多" +
      //       this.bigTurntable.totalMaxDrawNumber +
      //       "次, 活动期间每人每天中奖不限次，累计中奖不超过" +
      //       this.bigTurntable.totalMaxRewardNumber +
      //       "次";
      //   } else {
      //     text6 =
      //       "抽奖和中奖限制：每人每天最多抽奖次数" +
      //       this.bigTurntable.oneDayMaxDrawNumber +
      //       "次，活动期间累计抽奖最多" +
      //       this.bigTurntable.totalMaxDrawNumber +
      //       "次";
      //   }
      // }
      let prizes = [];
      this.currentPrizeList.filter(item => item.prizeType != 9).forEach(item => {
        prizes.push(`${item.title}X${item.totalAmount || 0}`);
      })
      let text6 = "\n三、【活动奖品】";
      let text7 = `活动奖品：${prizes.join("、")}；`;
      let text8 = `礼品数量有限，先到先得，有可能会有奖品擦肩而过情况；`;
      let Arr1 = [
        firstText,
        [secondText, text1,text5],
        [text6, text7, text8],
        [thirdText, precautions]
      ];
      let newText = "";

      Arr1.forEach((item, index) => {
        let newNum = 0;
        item.forEach((row, it) => {
          if (row.length > 0) {
            if (it != 0) {
              newText = newText + newNum + "." + row + "\n";
            } else {
              newText = newText + row + "\n";
            }
            newNum = newNum + 1;
          }
        });
      });
      this.ruleForm.ruleDescription = newText;
    },
    //清除
    cleanData(row, index) {
      row.assetsId = null;
      row.prizeType = 9;
      row.price = null;
      row.title = "谢谢参与";
      row.logo = null;
      row.percentage = "";
      row.memberBuyPercentage = "";
      row.singleAmount = null;
      row.totalAmount = null;
      row.dailyLimitType = 0;
      row.dailyLimit = null;
      row.busyLimit = null;
      row.idleLimit = null;
      row.singleMaxWin = "";
      row.shouldCollectExtraData = 0
      row.extraQuestion = null
      this.winningRate = 0;
      // 同步清空所有任务表格中对应奖品的中奖率
      for (const taskType in this.taskPrizeConfigs) {
        const taskPrizeList = this.taskPrizeConfigs[taskType];
        const correspondingTaskPrize = taskPrizeList.find(item => item.index === index);
        if (correspondingTaskPrize) {
          // 清空中奖率相关字段
          correspondingTaskPrize.percentage = "";
          correspondingTaskPrize.memberBuyPercentage = "";
        }
      }
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      if (row.percentage) {
        this.winningRate = this.winningRate.toFixed(5);
      }
    },
    //选择奖品弹窗
    centerVis(row) {
      // this.isSelectProduct = true;
      this.itemArr = this.prizeSettingList
      this.JingdouCount.prizeCount = row.totalAmount;
      this.index = row.index;
      this.echoDate = row;
      this.isSelectProduct = true
      this.$nextTick(()=>{
        this.$refs.selectProduct.openDialog();
      })
      console.log("this.JingdouCount.prizeCount", this.JingdouCount.prizeCount);
    },
    // 返回上一步
    returnBack() {
      if (this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      // this.$emit("returnBack");
      if (this.localStepNum == 0) this.$emit("returnBack");
      if (this.localStepNum == 1) this.localStepNum = 0;
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 获取奖品
    getTheData(data, prizeType) {
      if (prizeType == 1) {
        this.prizeSettingList[this.index].couponType = data.couponType;
        if(!data.logo) {
          // 优惠券默认logo
          data.logo = "https://cdn-image.yucrm.cn/images/V24/popup_coupon.png";
        }
      }
      if (data.giftType) {
        this.prizeSettingList[this.index].giftType = Number(data.giftType);
      }
      this.prizeSettingList[this.index].price = Number(data.discount);
      this.prizeSettingList[this.index].assetsId = Number(data.couponId || data.skuId);
      this.$set(this.prizeSettingList[this.index],'logo',data.logo);
      this.prizeSettingList[this.index].prizeType = prizeType;
      if (prizeType == 4) {
        this.prizeSettingList[this.index].title = data.discount + "店铺积分";
      } else {
        this.prizeSettingList[this.index].title = data.name;
      }
      if (data.singleAmount) {
        this.prizeSettingList[this.index].singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        this.prizeSettingList[this.index].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 3) {
          this.prizeSettingList[this.index].addressFillEndTime = data.addressFillEndTime
          this.prizeSettingList[this.index].predictSendTime = data.predictSendTime
          this.prizeSettingList[this.index].isFollowActivityEndTime = data.isFollowActivityEndTime
          this.prizeSettingList[this.index].shouldCollectExtraData = data.shouldCollectExtraData;
          this.prizeSettingList[this.index].extraQuestion = data.extraQuestion;
          this.prizeSettingList[this.index].addressFillLimit = data.addressFillLimit;
          this.prizeSettingList[this.index].commitAddressLimit = data.commitAddressLimit;
        if(!data.isGoodManage) {
          this.prizeSettingList[this.index].skuId = data.skuId;
          this.prizeSettingList[this.index].addressFillEndTime = data.addressFillEndTime;
          this.prizeSettingList[this.index].isFollowActivityEndTime = data.isFollowActivityEndTime;
          delete this.prizeSettingList[this.index].isGoodManage
        } else {
          this.prizeSettingList[this.index].isGoodManage = data.isGoodManage;
        }
      }
      // 实物随单发
      if(prizeType == 14 || prizeType == 1) {
        this.getPhysicalShipped(this.prizeSettingList[this.index],prizeType,data);
      }
      // 金豆、E卡、爱奇艺、PLUS、红包计划需要剩余份额
      if([2,5,6,7,8,10].includes(Number(prizeType))){
        this.prizeSettingList[this.index].budgetRemain = data.budgetRemain;
      }
      if(prizeType==3&&data.isGoodManage) {
        this.prizeSettingList[this.index].budgetRemain = data.budgetRemain;
      }
      this.isSelectProduct = false
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 下一步
    resetForm() {
      console.log(this.prizeSettingList, "obj");
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      //活动对象限制
      if (this.actMember == 2 &&(!this.ruleForm.partner || this.ruleForm.partner.length == 0)) {
        this.$message.warning("请选择活动对象");
        return;
      }
      if(this.actMember == 3 && !this.peopleSelected.length){
        this.$message.warning("请选择指定人群");
        return;
      }
      
      // 1.14迭代 这里判断 指定入会时间
      // if(this.actMember == '2'){
      //   if(this.ruleForm.ruleDTO.isCheckOpenCardTime&&(!this.ruleForm.ruleDTO.openCardStartTime||!this.ruleForm.ruleDTO.openCardEndTime)){
      //     return this.$message.warning("请选择入会时间");
      //   }
      // }
      if (this.actMember == "2") {
        if (
          this.ruleForm.firstOpenCardTimeType == 1 &&
          (!this.ruleForm.openCardBeforeDay)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
        if (
          this.ruleForm.firstOpenCardTimeType == 2 &&
          (!this.ruleForm.ruleDTO.openCardStartTime || !this.ruleForm.ruleDTO.openCardEndTime)
        ) {
          return this.$message.warning("请完善首次入会时间");
        }
      }

      // 抽奖机会
      if (this.raffleForm.drawType == 1) {
        let falg = false
        if(this.raffleForm.taskType == 1){
          if(!this.raffleForm.firstGiveTimes){
            // falg = true
          }
        }else{
          if(!this.raffleForm.everyDayGiveTimes){
            // falg = true
          }
        }
        if(falg){
          return this.$message.warning("请完善抽奖机会信息");
        }
      }else{
        if(!this.raffleForm.point){
          return this.$message.warning("请完善抽奖机会信息");
        }
      }
      // 任务校验
      if (this.taskDataList.length > 0) {
        // 检查邀请好友入会任务（type==18）的时间配置
        for (let task of this.taskDataList) {
          if (task.type == 18 && task.taskTime == 2) {
            // 任务时间是纯日期(yyyy-MM-dd)，活动时间带时分秒(yyyy-MM-dd HH:mm:ss)，
            // 直接字符串比较会因前缀匹配导致同一天的配置误判，统一转时间戳比较，
            // 且与 sureTask 中"任务有效期"校验的边界语义一致（开始日按 23:59:59、结束日按 00:00:00）
            const taskStartTime = new Date(task.startTime + " 23:59:59").getTime();
            const taskEndTime = new Date(task.endTime + " 00:00:00").getTime();
            const activityStartTime = new Date(this.ruleForm.startTime).getTime();
            const activityEndTime = new Date(this.ruleForm.endTime).getTime();
            if (activityStartTime > taskStartTime || taskEndTime > activityEndTime) {
              this.$message.warning('邀请好友入会任务配置有误');
              return;
            }
          }
        }
      }
      // 请将奖品填写完整！
      let isFlay = false;

      this.prizeSettingList.forEach((item) => {
        if (item.prizeType != 9) {
          if (!item.totalAmount) {
            isFlay = true;
          }
        }
      });
      
      if (isFlay) {
        return this.$message.warning("请将奖品填写完整！");
      }
      // 公活动配置校验
      if (!useValidateMoreActSet(this)) {
        return;
      }

      //新增进店设置校验
      if(this.ruleForm.goShopSetting==1 && !this.ruleForm.goShopAppId) {
        this.$message.warning("请输入小程序appId");
        return;
      }
      if(this.ruleForm.goShopSetting==2) {
        if(!this.ruleForm.goShopUrl) {
          this.$message.warning("请输入指定链接");
          return;
        }else if(!this.ruleForm.goShopUrl.startsWith('https://') || !this.ruleForm.goShopUrl.includes('jd.com')) {
          this.$message.warning("输入的内容非链接或为接口无法支持的链接，请重新设置");
          return;
        }
      }
      // 小程序分享标题
      if (!this.ruleForm.shareTitle) {
        this.$message.warning("请输入小程序分享标题");
        return;
      }
      // 小程序分享简介
      if (!this.ruleForm.shareIntroduce) {
        this.$message.warning("请输入小程序分享简介");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      if(this.placementPosition.length==0) {
        this.$message.warning("请选择活动投放位置！");
        return
      }
      this.joinBlackList = true;
    },
    // 保存草稿
    saveDraft(){
      //活动名称的限制
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      if(this.isDraftEdit){
        this.$confirm('是否保存对当前草稿的修改?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }else{
        this.$confirm('是否存为草稿?', '', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.isDraft = true
          this.handleDialogCloseAnoth()
        })
      }
    },
    async handleDialogCloseAnoth() {
      let obj = {};
      obj = this.deepClone(this.ruleForm);
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.bigTurntableDrawRuleDTO = {};

      // 抽奖和中奖限制
      if(this.bigTurntable.oneDayMaxDrawNumber){
        obj.bigTurntableDrawRuleDTO.oneDayMaxDrawNumber = this.bigTurntable.oneDayMaxDrawNumber
      }
      if(this.bigTurntable.totalMaxDrawNumber){
        obj.bigTurntableDrawRuleDTO.totalMaxDrawNumber = this.bigTurntable.totalMaxDrawNumber
      }
      if(this.bigTurntable.oneDayMaxRewardNumber){
        obj.bigTurntableDrawRuleDTO.oneDayMaxRewardNumber = this.bigTurntable.oneDayMaxRewardNumber
      }
      if(this.bigTurntable.totalMaxRewardNumber){
        obj.bigTurntableDrawRuleDTO.totalMaxRewardNumber = this.bigTurntable.totalMaxRewardNumber
      }

      obj.bigTurntableDrawRuleDTO.shareTitle = this.ruleForm.shareTitle
      obj.bigTurntableDrawRuleDTO.shareIntroduce = this.ruleForm.shareIntroduce
      obj.bigTurntableDrawRuleDTO.sharePic = this.ruleForm.sharePic

      // 进店逛逛配置
      obj.bigTurntableDrawRuleDTO.goShopSetting = this.ruleForm.goShopSetting,
      obj.bigTurntableDrawRuleDTO.goShopAppId = this.ruleForm.goShopAppId,
      obj.bigTurntableDrawRuleDTO.goShopUrl = this.ruleForm.goShopUrl,
      delete obj.goShopSetting
      delete obj.goShopAppId
      delete obj.goShopUrl

      // 获取抽奖机会方式
      obj.bigTurntableDrawRuleDTO.drawType = this.raffleForm.drawType

      // 赠送限制
      obj.bigTurntableDrawRuleDTO.giveLimitType = this.raffleForm.giveLimitType
      obj.bigTurntableDrawRuleDTO.customerPaperwork = JSON.stringify(this.customerPaperwork)

      // 任务赠送
      if(this.raffleForm.drawType == 1){
        if(this.raffleForm.taskType == 1){
          obj.bigTurntableDrawRuleDTO.firstGiveTimes = this.raffleForm.firstGiveTimes || 0;
        }
        if(this.raffleForm.taskType == 2){
          obj.bigTurntableDrawRuleDTO.everyDayGiveTimes = this.raffleForm.everyDayGiveTimes || 0;
        }
      }else{
        // 消耗积分
        obj.bigTurntableDrawRuleDTO.point = this.raffleForm.point
      }

      // 任务
      if(this.taskDataList.length){
        obj.taskList = this.taskDataList.map(item=>{
          const obj = {
            activityType: item.type == 8 || item.type == 12 || item.type == 7  || (item.type==16&&item.activityType==2)?2:1,
            taskType:item.type,
            taskValidity:item.taskTime,
          }
          if(item.id) {
            obj.id = item.id;
          }
          // 指定时间
          if(item.taskTime == 2){
            obj.startTime = item.startTime
            obj.endTime = item.endTime
          }
          // 商品
          if(item.skuIds.length){
            obj.skuIds = item.skuIds.join(",")

          }
          if(item.type == 18){
            obj.activityType = 2;
            obj.inviteLimit = item.condition;
            obj.taskDoLimit = item.condition2
          }
          // 浏览会场-跳转链接
          if(item.type == 5){
            obj.jumpUrl = item.jumpUrl
          }
          // 好友助力-邀请人数上限
          if(item.type == 8){
            obj.inviteLimit = item.inviteLimit
          }
          if(item.type == 17) {
            obj.activityType = 2;
            obj.orderCountType = item.orderCountType;
            obj.orderType = item.orderType
            obj.skuType = item.skuType
            // 提交指定商品规则，兜底为整单计算
            obj.statsSkuType = item.statsSkuType || 0
            obj.itemTotalLimit = item.itemTotalLimit
            obj.amtLimit = item.amtLimit
            obj.orderStartTime = item.orderStartTime
            obj.orderEndTime = item.orderEndTime;

            obj.giveType = item.giveType
            obj.countType = item.countType
            obj.taskDoType = item.taskDoType
            if(obj.giveType == 0){
              obj.taskDoType = 1
            }
            obj.venderIds = item.venderIds.join(",");
            obj.sellerSkuList = item.sellerSkuList.map((item)=>{
              return {
                skuIds: item.skuIds,
                venderId: item.venderId,
              }
            });
            obj.stepList = item.stepList
            obj.cancelOrderInvalid = item.cancelOrderInvalid
            obj.mergeOrder = item.mergeOrder
            obj.orderPaymentType = item.orderPaymentType
          }
          if(item.type == 20){
            obj.activityType = 2;
            obj.skuType = item.skuType
            // 提交指定商品规则，兜底为整单计算
            obj.statsSkuType = item.statsSkuType || 0
            obj.orderStartTime = item.orderStartTime
            obj.orderEndTime = item.orderEndTime;
            obj.countType = item.countType
            obj.stepList = this.taskOrderList
            obj.giveType = 1
            obj.taskDoType= 1
          }
          // 任务门槛上限
          if(this.conditionValue.includes(item.type)){
            if(item.type == 12||item.type == 16){
              obj.giveLimit = item.condition
              obj.taskDoLimit = item.condition2
            }else if(item.type == 4){
              // 加购商品
              obj.addCartLimit = item.condition
            } else if(item.type == 17) {
              obj.giveLimit = 1
              if((item.giveType == 0&&item.orderCountType == 0) || ((item.giveType == 1 || item.giveType == 2)&&item.taskDoType == 1)) {
                obj.taskDoLimit = item.condition2
              }else {
                obj.taskDoLimit = 1
              }
            } else if(item.type == 20) {
              obj.taskDoLimit = item.condition2
            }
            else{
              obj.giveLimit = item.condition
            }
          }
          if (item.type == 7 || item.type == 5){
            obj.giveLimit = item.giveLimit
          }
          if (item.type == 5){
            obj.viewTime = item.viewTime;
          }
          if (item.type == 23){
            obj.searchKeyword = item.searchKeyword;
            obj.activityType = 1;
            obj.giveLimit = 1;
          }
          return obj
        })
      }else{
        obj.taskList = []
      }
      obj.bigTurntableDrawPrizeDTOS = this.deepClone(this.prizeSettingList);


      obj.bigTurntableDrawPrizeDTOS.forEach((item, index) => {
        item.percentage = Number(item.percentage);
        item.memberBuyPercentage = Number(item.memberBuyPercentage);
        if (item.prizeType != 9) {
          if (item.prizeType == 3||item.prizeType == 10) {
            item.assetsId = item.skuId || item.assetsId;
          } else {
            item.singleAmount = 1;
          }
          if (item.prizeType == 2 || item.prizeType == 4) {
            item.singleAmount = item.price;
          }
        }
      });
      
      obj.templateJson = this.templateJson; //多个模板
      obj.allowLevel = this.ruleForm.partner&&this.ruleForm.partner.length ? this.ruleForm.partner.join(",") : ""; //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,

      // 1.14迭代 这里提交
      obj.bigTurntableDrawRuleDTO.isCheckOpenCardTime = this.actMember==2?this.ruleForm.ruleDTO.isCheckOpenCardTime:false
      obj.bigTurntableDrawRuleDTO.openCardStartTime = this.actMember==2?this.ruleForm.ruleDTO.openCardStartTime:''
      obj.bigTurntableDrawRuleDTO.openCardEndTime = this.actMember==2?this.ruleForm.ruleDTO.openCardEndTime:''
      obj.bigTurntableDrawRuleDTO.plusObject = this.ruleForm.ruleDTO.plusObject
      obj.luckyDrawForm = this.ruleForm.luckyDrawForm
      obj.bigTurntableDrawRuleDTO.guaranteedWinPrizeFlag = this.ruleForm.guaranteedWinPrizeFlag

      obj.bigTurntableDrawRuleDTO.firstOpenCardTimeType = this.ruleForm.firstOpenCardTimeType
      obj.bigTurntableDrawRuleDTO.openCardBeforeDay = this.ruleForm.openCardBeforeDay
      obj.bigTurntableDrawRuleDTO.openCardFollow = this.ruleForm.openCardFollow

      obj.bigTurntableDrawRuleDTO.cusTemplateJSON = this.cusTemplateJSON
      obj.bigTurntableDrawRuleDTO.isForceRemind = this.isForceRemind
      obj.isKeyActivity = this.isKeyActivity
      obj.placementPosition = this.placementPosition.join(",")

      obj.priceType = 0
      obj.isExposureItem = this.ruleForm.exposureSwitch ? 1 : 0
      obj.itemList = this.itemListFor //曝光商品集合
      obj.templateId = this.templateId

      if(this.actMember == 1){
        obj.allowLevel = "-1"
      }else if(this.actMember == 3){
        obj.allowLevel = "99"
        obj.crowdIds = this.peopleSelected.join(",")
      } else if (this.actMember == 2) {
        obj.allowLevel = this.ruleForm.partner&&this.ruleForm.partner.length ? this.ruleForm.partner.join(",") : "";
        if (obj.allowLevel == '-1') {
          //会员等级设置
          let list = ['-1','0']
          this.levelList.forEach((item,index) => {
            let num = index + 1
            list.push(num)
          })
          obj.allowLevel = list.join(",")
        }
      }
      // V2.5 => 复制，去除id和旧的模板数据
      if(this.activityData.isCopy){ 
        this.ids = "";
        delete obj.templateJson
      }
      // 概率配置
      obj.bigTurntableDrawRuleDTO.probabilityType = this.probabilityType;
      // 概率奖品设置
      obj.probabilityMap = Object.keys(this.taskPrizeConfigs).reduce((map, taskId) => {
        map[taskId] = this.taskPrizeConfigs[taskId].map(prize => ({
          prizeId: prize.id,
          prizeType: prize.prizeType,
          memberBuyPercentage: prize.memberBuyPercentage || 0,
          percentage: prize.percentage || 0
        }));
        return map;
      }, {});
      if (this.checked == true || this.isDraft) {
        if (this.ids == "" || this.isDraft || this.isDraftEdit) {
          if(this.isDraft){
            obj.status = 5
          }else{
            // 保存正式活动不需要status
            if(obj.status){
              delete obj.status
            }
          }
          // 草稿箱编辑-添加活动id
          if(this.isDraftEdit){
            obj.id = this.valueRow.id
          }
          if(this.activityData.isCopy){
            delete obj.id
          }
          bigTurntableDraw(obj)
            .then((res) => {
              if (res && res.code == 1) {
                if(this.isDraft){
                  this.$message.success("保存成功！")
                  this.$emit("returnBack",true);
                }else{
                  this.joinBlackList = false;
                  this.$router.push({
                    name: "throw",
                    query: {
                      id: res.data.id,
                      activityType: res.data.activityType,
                    },
                  });
                  this.$message.success(res.message);
                }
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        } else {
          delete obj.templateJson
          let res;
          if(this.activityData.isStart){
            let params = {
              startTime: obj.startTime,
              endTime: obj.endTime,
              templateId:this.templateId,
              ruleDto:obj.bigTurntableDrawRuleDTO,
              activityId: obj.id,
              // endTime: obj.endTime,
              ruleDescription: obj.ruleDescription,
              prizes: obj.bigTurntableDrawPrizeDTOS.filter(item=>item.totalAmount).map(item=>{
                return {
                  title:item.title,
                  prizeId: item.id,
                  totalAmount: !item.isWrite ? item.totalAmount : undefined,
                  dailyLimitType: item.dailyLimitType,
                  dailyLimit: item.dailyLimitType == '0' ? item.dailyLimit : '',
                  busyLimit: item.dailyLimitType == '1' ? item.busyLimit : '',
                  idleLimit: item.dailyLimitType == '1' ? item.idleLimit : '',
                  percentage: item.percentage,
                  memberBuyPercentage: item.memberBuyPercentage,
                  singleMaxWin: item.singleMaxWin,
                  isFollowActivityEndTime: item.isFollowActivityEndTime,
                  predictSendTime: item.predictSendTime,
                  addressFillEndTime: item.addressFillEndTime,
                  addressFillLimit: item.addressFillLimit,
                  // 提交地址限制：数组转逗号分隔字符串
                  commitAddressLimit: Array.isArray(item.commitAddressLimit) 
                    ? item.commitAddressLimit.join(',') 
                    : item.commitAddressLimit
                }
              }),
              isExposureItem: this.ruleForm.exposureSwitch ? 1 : 0,
              itemList: this.itemListFor,
              taskList: obj.taskList,
              isValidBlackList: obj.isValidBlackList
            }
            if(this.actEndTime!=this.activityEndTime) {
              params.endTime = this.activityEndTime
            }
            // 概率奖品设置
            params.probabilityMap = Object.keys(this.taskPrizeConfigs).reduce((map, taskId) => {
              map[taskId] = this.taskPrizeConfigs[taskId].map(prize => ({
                prizeId: prize.id,
                title:prize.title,
                prizeType: prize.prizeType,
                memberBuyPercentage: prize.memberBuyPercentage || 0,
                percentage: prize.percentage || 0
              }));
              return map;
            }, {});
            res = await updateCommon(params)
          } else {
            res = await modifyBigTurn(obj)
          }
          if (res && res.code == 1) {
            this.joinBlackList = false;
            this.$router.push({
              name: "throw",
              query: {
                id: res.data.id,
                activityType: res.data.activityType,
              },
            });
            this.$message.success(res.message);
          } else {
            if(res.message){
              this.$message.error(res.message);
            }else{
              this.$message.error(res.data.message);
            }
          }
        }
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.ids != "") {
        let id = this.ids;
        this.valueRow = {
          id: id,
        };
        getbigTurn(id)
          .then((res) => {
            res.data.partner = []
            let data = res.data;
            // tapd 进店逛逛
            data.goShopSetting = res.data.bigTurntableDrawRuleDTO.goShopSetting;
            data.goShopAppId = res.data.bigTurntableDrawRuleDTO.goShopAppId;
            data.goShopUrl = res.data.bigTurntableDrawRuleDTO.goShopUrl;
            this.ruleForm = data;
            this.ruleForm.activityName = res.data.activityName + (this.activityData.isCopy?"复制":"");
            this.ruleForm.condFollow = Boolean(res.data.condFollow);
            this.ruleForm.shareTitle = res.data.bigTurntableDrawRuleDTO.shareTitle;
            this.ruleForm.shareIntroduce = res.data.bigTurntableDrawRuleDTO.shareIntroduce;
            this.ruleForm.sharePic = res.data.bigTurntableDrawRuleDTO.sharePic;
            this.ruleForm.isValidBlackList = res.data.isValidBlackList;
            this.ruleForm.luckyDrawForm = res.data.luckyDrawForm;
            this.$set(this.ruleForm, 'guaranteedWinPrizeFlag', res.data.bigTurntableDrawRuleDTO.guaranteedWinPrizeFlag||0)
            this.ruleForm.partner = res.data.allowLevel.split(",");
            if(res.data.allowLevel == "99"){
              this.peopleSelected = res.data.crowdIds.split(",")
              this.actMember = "3"
            }else if(res.data.allowLevel == "-1"){
              this.actMember = "1"
              this.ruleForm.partner = ["-1"]
            }else{
              this.actMember = "2"
              if(res.data.allowLevel.indexOf('-1')!= -1 ){
                this.ruleForm.partner = ["-1"]
              }else{
                this.ruleForm.partner = res.data.allowLevel.split(",");
              }
            }
            console.log("this.ruleForm.partner ?????",this.ruleForm.partner)
            // 1.14迭代 这里回显
            this.ruleForm.ruleDTO = {
              isCheckOpenCardTime:res.data.bigTurntableDrawRuleDTO.isCheckOpenCardTime,
              openCardStartTime:res.data.bigTurntableDrawRuleDTO.openCardStartTime,
              openCardEndTime:res.data.bigTurntableDrawRuleDTO.openCardEndTime,
              plusObject:res.data.bigTurntableDrawRuleDTO.plusObject, //plus会员
            }
            this.$set(this.ruleForm, 'firstOpenCardTimeType', res.data.bigTurntableDrawRuleDTO.firstOpenCardTimeType)
            this.$set(this.ruleForm, 'openCardBeforeDay', res.data.bigTurntableDrawRuleDTO.openCardBeforeDay)
            this.$set(this.ruleForm, 'openCardFollow', res.data.bigTurntableDrawRuleDTO.openCardFollow)
            if(res.data.bigTurntableDrawRuleDTO.cusTemplateJSON){
              this.cusTemplateJSON = res.data.bigTurntableDrawRuleDTO.cusTemplateJSON
            }
            this.isForceRemind = res.data.bigTurntableDrawRuleDTO.isForceRemind ? res.data.bigTurntableDrawRuleDTO.isForceRemind : false
            this.isKeyActivity = res.data.isKeyActivity || 0
            this.placementPosition = res.data.placementPosition ? res.data.placementPosition.split(",") : ["SHOP"]
            this.templateId = res.data.templateId
            this.getPolite()
            // 获取抽奖机会方式回显
            this.raffleForm.drawType = res.data.bigTurntableDrawRuleDTO.drawType == 1?1:0
            this.raffleForm.taskType = res.data.bigTurntableDrawRuleDTO.firstGiveTimes != null ? 1 : 2
            // 赠送限制回显
            this.raffleForm.giveLimitType = res.data.bigTurntableDrawRuleDTO.giveLimitType || 0
            
            if(res.data.bigTurntableDrawRuleDTO.drawType == 1){
              this.raffleForm.firstGiveTimes = res.data.bigTurntableDrawRuleDTO.firstGiveTimes ? res.data.bigTurntableDrawRuleDTO.firstGiveTimes:null
              this.raffleForm.everyDayGiveTimes = res.data.bigTurntableDrawRuleDTO.everyDayGiveTimes ? res.data.bigTurntableDrawRuleDTO.everyDayGiveTimes:null
            }else{
               this.raffleForm.point = res.data.bigTurntableDrawRuleDTO.point
            } 
            // 任务列表
            if(res.data.bigTurntableDrawRuleDTO.drawType ==  1){
              const goodsPromise = []
              this.taskDataList = res.data.taskList.map(item=>{
                const obj = {
                  id: item.id,
                  type:item.taskType,
                  taskTime:item.taskValidity,
                  condition:null,
                  condition2:null,
                  count:null,
                  endTime:null,
                  startTime:null,
                  skuIds:[],
                  inviteLimit:null,
                  jumpUrl:null,
                  selectGoodsSkuList:[],
                  activityType: (item.taskType == 16 || item.taskType == 17 || item.taskType == 7) ? item.activityType : 1,
                  skuType: 0,
                  statsSkuType: 0, // 指定商品规则 0:整单计算 1:仅统计指定商品金额和件数
                  orderType: 0,
                  orderCountType: 1,
                  itemTotalLimit: null,
                  amtLimit: null,
                  orderEndTime: null,
                  orderStartTime: null,
                  mergeOrder: false,
                  orderPaymentType: 1,
                }
                // 指定时间
                if(item.taskValidity == 2){
                  obj.startTime = item.startTime
                  obj.endTime = item.endTime
                }
                // 商品
                if(item.skuIds){
                  obj.skuIds = item.skuIds.split(",")
                  let skuIdsLength = obj.skuIds.length;
                  let skuIds = obj.skuIds.toString();
                  goodsPromise.push(getTaobaoItemListSku({ current: 1, size: skuIdsLength, skuIds: skuIds.split(',') }))
                }
                // 浏览会场-跳转链接
                if(item.taskType == 5){
                  obj.jumpUrl = item.jumpUrl;
                  obj.viewTime = item.viewTime || 1;
                  obj.giveLimit = item.giveLimit || 1;
                }
                // 好友助力-邀请人数上限
                if(item.taskType == 8){
                  obj.inviteLimit = item.inviteLimit
                }
                if(item.taskType == 17) {
                  obj.orderCountType = item.orderCountType
                  obj.orderType = item.orderType
                  obj.skuType = item.skuType
                  // 指定商品规则回显，老数据无该字段时默认整单计算
                  obj.statsSkuType = item.statsSkuType || 0
                  obj.itemTotalLimit = item.itemTotalLimit
                  obj.amtLimit = item.amtLimit
                  obj.orderStartTime = item.orderStartTime
                  obj.orderEndTime = item.orderEndTime
                  obj.giveType = item.giveType
                  obj.countType = item.countType
                  obj.taskDoType= item.taskDoType
                  if(obj.giveType == 0){
                    obj.taskDoType = 1
                  }
                  obj.venderIds =
                    item.venderIds
                      ? item.venderIds.split(",").map((item) => +item)
                      : [this.$store.getters.loginUserInfo.venderId];
                  obj.sellerSkuList = item.sellerSkuList&&item.sellerSkuList.length?item.sellerSkuList:[{
                    skuIds: item.skuIds ? item.skuIds.split(",") : [],
                    venderId: this.$store.getters.loginUserInfo.venderId,
                    itemList: [],
                  }];
                  if (this.activityData.isCopy||this.isDraftEdit) {
                    // 跨店复制
                    if(obj.venderIds.length>0) {
                      let index = obj.venderIds.findIndex((item)=>{
                        return item == this.venderId
                      })
                      if(index==-1) {
                        obj.venderIds.unshift(Number(this.venderId))
                        obj.sellerSkuList.unshift({
                          venderId: Number(this.venderId),
                          skuIds: [],
                          itemList: [],
                        })
                      }
                    }
                  }
                  this.taskLevelList = item.stepList
                  this.selectGoodsSkuList = item.itemList
                  obj.selectGoodsSkuList = item.itemList
                  obj.stepList = item.stepList;
                  obj.cancelOrderInvalid = item.cancelOrderInvalid || 0;
                  obj.mergeOrder = item.mergeOrder || false
                  obj.orderPaymentType = item.orderPaymentType===null?1:item.orderPaymentType;
                }
                if(item.taskType == 20) {
                  obj.skuType = item.skuType
                  // 指定商品规则回显，老数据无该字段时默认整单计算
                  obj.statsSkuType = item.statsSkuType || 0
                  obj.orderStartTime = item.orderStartTime
                  obj.orderEndTime = item.orderEndTime
                  obj.countType = item.countType
                  this.taskOrderList = item.stepList&&item.stepList.length>0?item.stepList:[]
                  this.selectGoodsSkuList = item.itemList
                  this.hasSelectGoods = item.itemList || []
                  obj.selectGoodsSkuList = item.itemList
                }
                if (item.taskType == 18) {
                  obj.condition = item.inviteLimit
                  obj.condition2 = item.taskDoLimit
                }
                if (item.taskType == 23) {
                  obj.searchKeyword = item.searchKeyword
                }
                // 任务门槛上限
                const taskTypeObj = this.taskTypeOptions.find(option=>option.value == item.taskType)
                if(this.conditionValue.includes(item.taskType)){
                  if(item.taskType == 12){
                    obj.condition = item.giveLimit
                    obj.condition2 = item.taskDoLimit
                  }else if(item.taskType == 4){
                    obj.condition = item.addCartLimit
                    obj.count = taskTypeObj.taskCount
                  }else if(item.taskType == 16){
                    obj.condition = item.giveLimit
                    obj.condition2 = item.taskDoLimit
                    obj.activityType = item.activityType
                  }else if (item.taskType == 17) {
                    obj.activityType =  2;
                    obj.condition = item.giveLimit
                    obj.condition2 = item.taskDoLimit
                    obj.count = taskTypeObj.taskCount
                  } else if (item.taskType == 20) {
                    obj.activityType =  2;
                    obj.condition2 = item.taskDoLimit
                  }else{
                    obj.condition = item.giveLimit
                    obj.count = taskTypeObj.taskCount
                  }
                }else{
                  obj.condition = taskTypeObj.taskCondition
                  obj.count = taskTypeObj.taskCount
                }
                if(item.taskType == 7){
                  obj.giveLimit = item.giveLimit
                }
                return obj
              })
              Promise.all(goodsPromise).then(res=>{
                this.taskDataList.filter(item=>item.skuIds && item.skuIds.length).forEach((item,index)=>{
                  item.selectGoodsSkuList = res[index].data.records
                })
              })
              console.log(this.taskDataList,'nnnn');
            }
            this.customerPaperwork = res.data.bigTurntableDrawRuleDTO.customerPaperwork ? JSON.parse(res.data.bigTurntableDrawRuleDTO.customerPaperwork) : {}
            // 概率配置
            this.probabilityType = res.data.bigTurntableDrawRuleDTO.probabilityType
            // 任务类型列表回显
            this.selectedTaskTypes = Object.keys(res.data.probabilityMap || {}).map(key => parseInt(key));
            const prizeSettingList = res.data.bigTurntableDrawPrizeDTOS;
            prizeSettingList.forEach((item, index) => {
                item.minNum = item.totalAmount
                item.index = index;
                item.isWrite = false
                if (item.percentage) {
                  this.winningRate += Number(item.percentage);
                }
                // 提交地址限制回显：逗号分隔字符串转数字数组
                if (item.prizeType == 3) {
                  if (item.commitAddressLimit) {
                    item.commitAddressLimit = typeof item.commitAddressLimit === 'string'
                      ? item.commitAddressLimit.split(',').map(Number)
                      : item.commitAddressLimit;
                  } else {
                    item.commitAddressLimit = [0];
                  }
                }
            });
            // v2.5 => 复制不需要回显奖品和规则
            if(!this.activityData.isCopy){
              // 抽奖和中奖限制回显
              this.bigTurntable = res.data.bigTurntableDrawRuleDTO;
              this.prizeSettingList = prizeSettingList
              this.ruleForm.radio = res.data.priceType; // 0：显示京东价 1：显示促销价 ,
              this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
              this.selectGoodsArr = res.data.itemList;
              this.mainImagelist = res.data.itemList;
              this.itemListFor = res.data.itemList;
            } else {
              this.prizeSettingList = prizeSettingList.map((item, index) => {
                if(item.prizeType != 3) {
                  item = {
                    index: index,
                    prizeType: 9,
                    price: null,
                    title: "谢谢参与",
                    totalAmount: null,
                    dailyLimit:null,
                    dailyLimitType: 0,
                    percentage: null,
                    memberBuyPercentage: null
                  }
                } else {
                  item = {...item,index: index}
                  delete item.id
                }
                return item
              })
            }
            // 概率奖品设置
              const probabilityMap = res.data.probabilityMap || {};
              this.taskPrizeConfigs = {};
              for (const taskType in probabilityMap) {
                const taskPrizeList = probabilityMap[taskType];
                this.taskPrizeConfigs[taskType] = taskPrizeList.map((prize, index) => {
                  // 从 prizeSettingList 中找到对应的奖品信息
                  const correspondingPrize = this.prizeSettingList.find(item =>
                    item.id === prize.prizeId || item.index === index
                  ) || {};
                  return {
                    ...correspondingPrize, 
                    memberBuyPercentage: prize.memberBuyPercentage,
                    percentage: prize.percentage,
                    prizeId: prize.prizeId,
                    prizeType: prize.prizeType,
                    index: index
                  };
                });
              }
            this.templateJson = JSON.parse(res.data.templateJson);
            this.activityStartTime = res.data.startTime?res.data.startTime:null
            this.activityEndTime = res.data.endTime?res.data.endTime:null
            this.actEndTime = res.data.endTime
            this.activityTimeChange();
            this.winningRate = this.winningRate.toFixed(5);
            // v2.5 => 复制不需要回显奖品和规则
            if(this.activityData.isCopy){
              this.ruleForm.ruleDescription = ""
            }
          })
          .catch((res) => {});
      } else {
        this.hdTaskTemplateGroup();
        // 新增-默认活动时间
        this.activityStartTime = this.$getDate(30)[0]
        this.activityEndTime = this.$getDate(30)[1]
        this.activityTimeChange();
      }
    },
    // 添加任务-添加任务-下单时间监听
    handleOrderStart() {

    },
    //清空时间
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
      this.activityStartTime = null
      this.activityEndTime = null
    },
    // 清空任务时间
    clearTaskTime(){
      this.taskForm.startTime = "";
      this.taskForm.endTime = "";
    },
    // 清空下单时间
    clearOrderTime(){
      this.taskForm.orderStartTime = "";
      this.taskForm.orderEndTime = "";
    },
    // 控制大于0 - 正数可包含小数点
    validateInput(value) {
      let newValue = value.replace(/[^0-9.]/g, ''); // 过滤非数字和小数点
      let decimalIndex = newValue.indexOf('.');
      if (decimalIndex !== -1) {
        newValue = newValue.slice(0, decimalIndex + 1) + newValue.slice(decimalIndex + 1).replace(/\./g, '');
      }
      if (parseFloat(newValue) > 999999.99) {
        newValue = '999999.99'; // 设置为最大值
      }
      this.taskForm.amtLimit = newValue.replace(/^0+(\d)/, '$1');
    },
    validateInputNew(value) {
      let newValue = value.replace(/[^0-9]/g, ''); // 只允许数字
      if (newValue.length > 0) {
        newValue = newValue.replace(/^0+/, ''); // 移除前导零
        if (newValue === '') {
          newValue = '0';
        }
      }
      if (parseInt(newValue) > 999) {
        newValue = '999'; // 设置为最大值
      }

      this.taskForm.itemTotalLimit = newValue;
    },

        // 控制大于0 - 正数可包含小数点
    inputValidateInput(value) {
      let newValue = value.replace(/[^0-9.]/g, ''); // 过滤非数字和小数点
      let decimalIndex = newValue.indexOf('.');
      if (decimalIndex !== -1) {
        newValue = newValue.slice(0, decimalIndex + 1) + newValue.slice(decimalIndex + 1).replace(/\./g, '');
      }
      if (parseFloat(newValue) > 999999.99) {
        newValue = '999999.99'; // 设置为最大值
      }
      return newValue.replace(/^0+(\d)/, '$1');
    },
    inputValidateInputNew(value) {
      let newValue = value.replace(/[^0-9]/g, ''); // 只允许数字
      if (newValue.length > 0) {
        newValue = newValue.replace(/^0+/, ''); // 移除前导零
        if (newValue === '') {
          newValue = '0';
        }
      }
      if (parseInt(newValue) > 999) {
        newValue = '999'; // 设置为最大值
      }

      return newValue;
    },
    handleBlur() {
      if (Number(this.taskForm.amtLimit) === 0) {
        this.taskForm.amtLimit = '0';
      }
    },
    // 活动时间改变
    activityTimeChange() {
      console.log("this.activityStartTime", this.activityStartTime)
      console.log("this.activityEndTime", this.activityEndTime)
      this.ruleForm.startTime = this.activityStartTime;
      this.ruleForm.endTime = this.activityEndTime;
      this.$nextTick(() => {
        if(this.ruleForm.endTime && this.ruleForm.startTime){
          let nowTime = new Date().getTime();
          let start = new Date(this.ruleForm.startTime).valueOf();
          let end = new Date(this.ruleForm.endTime).valueOf();
          let invalidateDate = new Date(this.$store.getters.pointUserInfo.expiredIn).valueOf();
          let hdInvalidateDate = new Date(this.$store.getters.loginUserInfo.expiresIn).valueOf();
          this.timeDay = Math.floor(
            Math.abs(
              new Date(this.ruleForm.endTime) -
                new Date(this.ruleForm.startTime)
            ) /
              1000 /
              60 /
              60 /
              24
          );
          //计算小时
          const date3 = new Date(this.ruleForm.endTime).getTime() - new Date(this.ruleForm.startTime).getTime();
          const leave1 = date3 % (24 * 3600 * 1000);
          this.timeOut = Math.floor(leave1 / (3600 * 1000));
          // 查看不需要校验
          if(!this.backgroundOpacity){
            if (start < nowTime) {
              if (this.ids) {
                this.disableTime = true;
              } else {
              }
            }
            if (end < nowTime) {
              this.$message.warning("结束时间不能小于当前时间");
            }
            if (end < start) {
              this.$message.warning("结束时间不能小于开始时间");
              return;
            }
            if (end > invalidateDate) {
              this.$message.warning("活动时间不能超过软件有效期，请重新选择");
              this.activityEndTime = null;
              this.ruleForm.endTime = null;
              return;
            }
            if (end > hdInvalidateDate) {
              this.$message.warning("活动时间不可超过互动数据授权有效期！");
              this.activityEndTime = null;
              this.ruleForm.endTime = null;
              return;
            }
          }
        }
      });
    },

    // 选择礼品
    choosegifts() {},
    // 保留小数点后两位
    oninput2(val,$index,type = 1) {
      // debugger
      if (val < 0) {
        val = "";
      } else if (val > 100) {
        val = "100";
      }
      // 转换为数字进行计算
      const currentValue = parseFloat(val) || 0;
      // 计算当前所有奖项的中奖率总和（不包含当前正在编辑的项）
      let sumWithoutCurrent = 0;
      this.currentPrizeList.forEach((item, index) => {
        if (index !== $index && item.percentage) {
          sumWithoutCurrent += parseFloat(item.percentage);
        }
      });
      
      // 检查加上当前输入后是否超过100
      if (sumWithoutCurrent + currentValue > 100) {
        // 自动调整当前项的值，确保总和不超过100
        val = (100 - sumWithoutCurrent).toString();
      }

      let winningRate = 0;
      let totalMemberBuyPercentage = 0
      this.currentPrizeList.forEach((item,index) => {
        if (item.percentage) {
          winningRate += parseFloat(item.percentage).toFixed(5) * 1
        }
        if(type === 2){
          totalMemberBuyPercentage += item.memberBuyPercentage * 1;
        }
        if($index==index) {
          item.isWrite = true
        }
      });

      // if (winningRate > 100) {
      //   val = parseFloat(parseFloat(100) - (winningRate - val*1));
      // } else if (winningRate == 100) {
      //   if (val >= 100) {
      //     val = "100";
      //   } else {
      //     val = parseFloat(parseFloat(100) - (winningRate - val*1));
      //     if (val == 0) {
      //       val = "";
      //     }
      //   }
      // }
      // 入会且已购中奖率
      if(type === 2){
        if (totalMemberBuyPercentage > 100) {
          val = String(100 - (totalMemberBuyPercentage - val));
        } else if (totalMemberBuyPercentage == 100) {
          if (val >= 100) {
            val = "100";
          } else {
            val = String(100 - (totalMemberBuyPercentage - val));
            if (val == 0) {
              val = "";
            }
          }
        }
      }
      
      // if (val == 0) {
      //   val = "";
      // }
      val = val.substring(0, 10);

      this.theNum++;
      if(type==2) {
        return val ? val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3") : "";
      } else {
       return val ? val.replace(".", "$#$").replace(/\./g, "").replace("$#$", ".").replace(/[^\d.]/g, "").replace(/^(\-)*(\d+)\.(\d{1,5}).*$/, "$1$2.$3") : "";
      }
      
    },
    oninput(val) {
      if (val && val <= 0) {
        val = "1";
      }
      return val;
    },
    clickLocalStep() {
      if (this.backgroundOpacity) {
        this.$emit("returnBack");
        return;
      }
      if(!this.activityData.isCopy && this.valueRow && this.valueRow.id) {
        this.$emit("returnBack");
        return;
      }
      this.localStepNum = 0;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    // 新增任务
    addTask(){
      this.isTaskEdit = false
      this.taskDialog = true
      this.taskForm = {
        giveType:0,
        countType:1,
        taskDoType:0,

        type:1,
        taskTime:1,
        condition:null,
        condition2:null,
        count:null,
        endTime:null,
        startTime:null,
        skuIds:[],
        selectGoodsSkuList:[],
        inviteLimit:null,
        jumpUrl:null,
        activityType: 2,
        skuType: 0,
        statsSkuType: 0, // 指定商品规则 0:整单计算 1:仅统计指定商品金额和件数
        orderType: 0,
        orderCountType: 1,
        itemTotalLimit: null,
        amtLimit: null,
        orderEndTime: null,
        orderStartTime: null,
        venderIds:[],
        sellerSkuList:[],
        cancelOrderInvalid: 0,
        orderPaymentType: 1,
        mergeOrder: false
      }
      this.selectGoodsSkuList = []
      this.taskTypeChange(1)
    },
    // 关闭
    taskClose(){
      this.taskIsLook = false
      this.taskDialog = false
    },
    // 任务类型change
    taskTypeChange(e){
      const obj = this.taskTypeOptions.find(item=>item.value == e)
      if(!this.conditionValue.includes(e)){
        this.taskForm.condition = obj.taskCondition
      }else{
        this.taskForm.condition = null
        this.taskForm.condition2 = null
        this.taskForm.activityType = 2
      }
      // 任务次数
      if(e == 12){
        this.taskForm.count = null
      }else{
        this.taskForm.count = obj.taskCount
      }
      // 购买商品 - tip：不能加入goodsTypeList 因为保存时不做限制
      if(this.taskForm.type == 17) {
        this.initData()
        this.taskForm.skuIds = [];
        this.selectGoodsSkuList = [];
        this.taskForm.selectGoodsSkuList = [];
        this.taskForm.giveType = 0
        this.goodsLimit = 500
      }
      // 商品
      if(this.goodsTypeList.includes(e)){
        this.taskForm.skuIds = []
        this.selectGoodsSkuList = []
        this.taskForm.selectGoodsSkuList = []
      }
      if(e==20) {
        this.taskForm.countType=2
        this.taskOrderList = [
          {
            taskIndex:1,
            limit:'',
            giveNum:'',
          }
        ]
      }
      this.taskForm.taskTime = 1
    },
    isMonotonicIncreasing(arr) {
      return arr.every((value, index, array) => {
        return index === 0 || parseFloat(value) > parseFloat(array[index - 1]);
      });
    },
    // 确认添加任务
    sureTask(){
      console.log("this.taskForm", this.taskForm)
      // 任务有效期
      if(this.taskForm.taskTime == 2){
        if(!this.taskForm.startTime || !this.taskForm.startTime){
          return this.$message.warning('请填写任务有效期')
        }
        if(this.taskForm.startTime && this.taskForm.endTime){
          const startTime = new Date((this.taskForm.startTime + " 23:59:59")).getTime()
          const endTime = new Date((this.taskForm.endTime + " 00:00:00")).getTime()
          const activityStartTime = new Date(this.activityStartTime).getTime() 
          const activityEndTime = new Date(this.activityEndTime).getTime()
          if(startTime > endTime){
            return this.$message.warning('结束时间不能小于开始时间')
          }
          if(activityStartTime > startTime || endTime > activityEndTime){
            return this.$message.warning('任务有效期超出了活动时间范围，请重新选择')
          }
        }
      }
      // 邀请人数上限
      if(this.taskForm.type == 8){
        if(!this.taskForm.inviteLimit){
          return this.$message.warning('请填写邀请人数上限')
        }
      }
      // 跳转链接
      if(this.taskForm.type == 5){
        if(!this.taskForm.jumpUrl){
          return this.$message.warning('请填写跳转链接')
        }
      }
      // 购买商品类型
      if(this.taskForm.type == 17) {
        // 下单时间-------------
        if(!this.taskForm.orderStartTime || !this.taskForm.orderEndTime){
          return this.$message.warning('请填写下单时间')
        }
        if(this.taskForm.orderStartTime && this.taskForm.orderEndTime){
          const startTime = new Date((this.taskForm.orderStartTime + " 00:00:00")).getTime()
          const endTime = new Date((this.taskForm.orderEndTime + " 00:00:00")).getTime()
          if(startTime > endTime){
            return this.$message.warning('下单结束时间不能小于下单开始时间')
          }
        }
        // 订单金额-------------
        if(!this.taskForm.amtLimit&&this.taskForm.giveType == 0){
          return this.$message.warning('请填写订单金额')
        }
        // 指定商品-------------
        // if(this.taskForm.skuType == 1 && (!this.taskForm.skuIds.length || this.taskForm.skuIds.length < 1)){
        //   return this.$message.warning('请选择指定商品')
        // }
        if (this.taskForm.skuType == 1) {
          const obj = this.taskForm.sellerSkuList.find((item) => {
            return item.skuIds.length == 0;
          });
          if (obj) {
            const shop = this.multiShopGoods.find((item) => {
              return item.venderId == obj.venderId;
            });
            return this.$message.warning(`请选择${shop.shopTitle}的指定商品`);
          }
        }
        if(this.taskForm.giveType == 1||this.taskForm.giveType == 2){
          let isLimit = false
          let isLimitZero = false
          this.taskLevelList.forEach(item=>{
            if(!item.limit||!item.giveNum){
              isLimit = true
            }
            if(item.limit == 0 && item.limit != ""){
              isLimitZero = true
            }
          })
          if(isLimitZero){
            return this.$message.warning('任务条件值需大于0')
          }
          if(isLimit){
            return this.$message.warning('请填写任务条件')
          }
          if(!this.taskForm.condition2&&this.taskForm.taskDoType == 1){
            return this.$message.warning('请填写任务次数')
          }
        }
        // 单笔订单-任务次数
        if(this.taskForm.orderCountType == 0 && !this.taskForm.condition2 && this.taskForm.giveType == 0){
          return this.$message.warning('请填写任务次数')
        }

        if(this.taskForm.giveType == 2){
          let limitArr = []
          let giveNumArr = []
          this.taskLevelList.forEach(item=>{
            limitArr.push(item.limit)
            giveNumArr.push(item.giveNum)
          })
          if(!this.isMonotonicIncreasing(limitArr)){
            return this.$message.warning('高级阶梯笔数需大于低级阶梯笔数')
          }
          if(!this.isMonotonicIncreasing(giveNumArr)){
            return this.$message.warning('高级阶梯抽奖机会需大于低级阶梯抽奖机会')
          }
        }
        if((this.taskForm.giveType == 1||this.taskForm.giveType == 2)&&this.taskForm.taskDoType == 1){
          let number = 0
          this.taskLevelList.forEach(item=>{
            number = Number(item.giveNum) + number
          })
          if(Number(this.taskForm.condition2)<number){
            return this.$message.warning('任务次数不可低于任务条件可得抽奖机会')
          }
        }
      }

      if(this.taskForm.type == 20){
        if(!this.taskForm.orderStartTime || !this.taskForm.orderEndTime){
          return this.$message.warning('请填写下单时间')
        }
        if(this.taskForm.orderStartTime && this.taskForm.orderEndTime){
          const startTime = new Date((this.taskForm.orderStartTime)).getTime()
          const endTime = new Date((this.taskForm.orderEndTime)).getTime()
          const activityEndTime = new Date(this.activityEndTime).getTime()
          if(startTime > endTime){
            return this.$message.warning('下单结束时间不能小于下单开始时间')
          }
          if(endTime > activityEndTime){
            return this.$message.warning('下单结束时间不能晚于活动结束时间')
          }
        }
        // 指定商品-------------
        if(this.taskForm.skuType != 0 && (!this.taskForm.skuIds.length || this.taskForm.skuIds.length < 1)){
          return this.$message.warning(`请选择${this.taskForm.skuType==1 ? "指定": "排除"}商品`)
        }
        let isLimit = false
        let isLimitZero = false
        this.taskOrderList.forEach(item=>{
            if(!item.limit||!item.giveNum){
              isLimit = true
            }
            if(item.limit == 0 && item.limit != ""){
              isLimitZero = true
            }
          })
          if(isLimitZero){
            return this.$message.warning('任务条件值需大于0')
          }
          if(isLimit){
            return this.$message.warning('请填写任务条件')
          }
          if(!this.taskForm.condition2){
            return this.$message.warning('请填写任务次数')
          }
          if(Number(this.taskOrderList[0].giveNum)>Number(this.taskForm.condition2)){
            return this.$message.warning('任务次数不能小于任务条件的抽奖次数')
          }
      }

      // 任务条件
      if(this.conditionValue.includes(this.taskForm.type)&& this.taskForm.type != 17&&this.taskForm.type != 20){
        if(!this.taskForm.condition){
          return this.$message.warning('请填写任务条件')
        }
      }
      // 商品
      if(this.goodsTypeList.includes(this.taskForm.type)){
        if(this.taskForm.skuIds.length == 0){
          const obj = this.taskTypeOptions.find(item=>item.value == this.taskForm.type)
          return this.$message.warning(`请填写${obj.label}`)
        }else if(this.goodsLimitList.includes(this.taskForm.type) && this.taskForm.condition > this.taskForm.skuIds.length){
          return this.$message.warning(`任务商品件数不得大于已选商品件数，请重新选择~`)
        }
      }
      // 任务次数
      if(this.taskForm.type == 18 || this.taskForm.type == 12 ||this.taskForm.type == 16 || (this.taskForm.type == 17 && this.taskForm.orderCountType == 0 && this.taskForm.giveType == 0)){
        if(!this.taskForm.condition2){
          return this.$message.warning('请填写任务次数')
        }
      }
      // 抽奖次机会
      if(this.taskForm.type == 7){
        if(!this.taskForm.giveLimit){
          return this.$message.warning('请填写抽奖次数')
        }
      }
      // 搜索关键词
      if(!this.taskForm.searchKeyword && this.taskForm.type == 23) {
        this.$message.warning('请输入搜索关键词');
        return;
      }
      if(this.taskForm.type == 5) {
        if(!this.taskForm.viewTime){
          return this.$message.warning('请输入浏览时间')
        } 
        if(!this.taskForm.giveLimit){
          return this.$message.warning('请输入抽奖次数')
        }
      }
      const obj = JSON.parse(JSON.stringify(this.taskForm))
      if(this.taskForm.type == 17){
        obj.stepList = JSON.parse(JSON.stringify(this.taskLevelList))
      }else if(this.taskForm.type == 20){
        obj.stepList = JSON.parse(JSON.stringify(this.taskOrderList))
      }
      console.log("obj", obj);
      // return;
      const index = this.taskDataList.findIndex(item=>item.type == this.taskForm.type )
      if(index != -1 && !this.isTaskEdit){
        return this.$message.warning('列表已存在该类型任务，请勿重复添加~')
      }else{
        // 修改
        if(this.isTaskEdit){
          const index = this.taskDataList.findIndex(item=>item.type == this.taskRow.type )
          this.taskDataList.splice(index,1,obj)
        }else{
          this.taskDataList.push(obj)
        }
      }
    this.taskDialog = false
    },
    // 修改
    editTask(row,isLook){
      const copyRow = JSON.parse(JSON.stringify(row))
      this.taskRow = row
      this.isTaskEdit = true
      this.taskForm = copyRow
      // 指定商品规则兜底，老数据无该字段时默认整单计算
      this.taskForm.statsSkuType = copyRow.statsSkuType || 0
      // 商品回显
      this.selectGoodsSkuList = copyRow.selectGoodsSkuList
      this.taskDialog = true

      this.taskIsLook = isLook
      // 购买商品新增下单店铺回显处理
      if (this.taskForm.type == 17) {
        this.goodsLimit = 500
        this.initData();
        if(this.taskForm.skuType ==1) {
          const isReq = this.taskForm.sellerSkuList.some((item) => {
            return item.itemList&&item.itemList.length>0;
          });
          if (!isReq) {
            const reqList = this.taskForm.sellerSkuList.map((item) => {
              return getTaobaoItemListSku({
                current: 1,
                size: item.skuIds.length,
                skuIds: item.skuIds,
                venderId: item.venderId,
              });
            });
            Promise.all(reqList).then((res) => {
              res.forEach((itemRes, index) => {
                this.taskForm.sellerSkuList[index].itemList = itemRes.data.records;
              });
            });
          }
        }
      } else {
        this.goodsLimit = 100
      }
    },
    // 删除
    deleteTask(row){
      const index = this.taskDataList.findIndex(item=>item.type == row.type )
      this.taskDataList.splice(index,1)
    },
    // 上移
    upTask(index){
      this.taskDataList[index] = this.taskDataList.splice(index - 1,1,this.taskDataList[index])[0]
    },
    // 下移
    downTask(index){
      this.taskDataList[index] = this.taskDataList.splice(index + 1,1,this.taskDataList[index])[0]
    },
    // 商品组件回调
    selectGoodsChange(val) {
      if (val) {
        let isGoods = false
        val.forEach(item=>{
          if(item.skuStatus != 1){
            isGoods = true
          }
        })
        //加权限判断
        if(this.isPremissionShow){
          if(isGoods){
           return this.$message.warning('当前所选商品包含下架商品，请重新选择')
         }
        }
   
        let valArr = [];
        this.selectGoodsSkuList = val
        this.taskForm.selectGoodsSkuList = val;
        val.forEach((i) => {
          valArr.push(i.skuId);
        });
        console.log(valArr)
        this.taskForm.skuIds = valArr
      }
      this.goodsState = false;
    },
    // 商品弹窗
    showGoods(limit = 100){
      this.goodsLimit = limit
      this.goodsState = true
    },
    // 每日发放限额弹窗
    setLimit(row) {
      if (!row.totalAmount) {
        return this.$message.warning("请先输入奖品总数");
      }
      this.showLimitDialog = true
      this.limitData = row
    },
    // 每日发放限额弹窗确认
    handleLimitConfirm(data) {
      this.$set(this.limitData, 'dailyLimitType', data.dailyLimitType)
      this.$set(this.limitData, 'dailyLimit', data.dailyLimit)
      this.$set(this.limitData, 'idleLimit', data.idleLimit)
      this.$set(this.limitData, 'busyLimit', data.busyLimit)

      if (data.dailyLimitType == 0) { // 每日发放
        this.$delete(this.limitData, 'idleLimit')
        this.$delete(this.limitData, 'busyLimit')
      } else if (data.dailyLimitType == 1) { // 按闲忙时配置数量
        this.$delete(this.limitData, 'dailyLimit')
      }
    },
    handleTabClick(tab) {
      console.log('切换到tab:', tab.name);
      console.log("--- ~ this.isTaskTab:---", this.isTaskTab)
      this.activeProbabilityTab = tab.name;
      // 如果切换到任务tab且该任务还没有配置，复制通用配置
      if (tab.name !== 'common' && !this.taskPrizeConfigs[tab.name]) {
        this.$set(this.taskPrizeConfigs, tab.name, 
          JSON.parse(JSON.stringify(this.prizeSettingList))
        );
      }
      // 重新计算累计中奖率
      this.winningRate = 0;
      this.currentPrizeList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      this.winningRate = this.winningRate.toFixed(5);
      // TODO: 任务差异数据都存在 this.taskPrizeConfigs里面
      console.log("--- ~ this.taskPrizeConfigs:---", this.taskPrizeConfigs)
      console.log("--- ~ this.prizeSettingList:---", this.prizeSettingList)
    },
    handleProbabilityChange(selectedValues) {
      // 如果值为1, 且任务列表为空, 则重新选择为0, 且提示
      if(selectedValues == 1 && this.taskDataList.length == 0){
        this.probabilityType = 0
        this.$message.warning('请先添加任务')
      }
    },
    // 处理任务类型选择变化
    handleTaskTypesChange(selectedValues) {
      console.log('选中的任务类型:', selectedValues);
      // 清理不再选中的任务配置
      Object.keys(this.taskPrizeConfigs).forEach(taskKey => {
        const taskType = taskKey.replace('task_', '');
        if (!selectedValues.includes(parseInt(taskType))) {
          this.$delete(this.taskPrizeConfigs, taskKey);
        }
      });
      // 如果当前激活的tab对应的任务被取消选择，切换回通用tab
      if (this.activeProbabilityTab !== 'common') {
        const currentTaskType = this.activeProbabilityTab.replace('task_', '');
        if (!selectedValues.includes(parseInt(currentTaskType))) {
          this.activeProbabilityTab = 'common';
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.titleBox){
  margin: 16px 0;
}
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  height: 100%;
  background-color: #fff;
  border-radius: 6px;
  // margin: 11px 20px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #fe4d45;
            border-bottom: 1px solid #fe4d45;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #fe4d45;
            border-left: 1px solid #fe4d45;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          width: 206px;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 28px 28px 1px 24px;
    margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #fe4d45;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #fe4d45;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 13px 30px;
      background: #fffaee;
      font-size: 13px;
      color: #333;
      i {
        color: #fe8f8a;
        opacity: 0.7;
      }
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin-top: 8px;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #fe4d45;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #fe4d45;
      }
    }
    .set {
      display: inline-block;
      margin-top: 30px;
    }
    .desc {
      margin-left: 20px;
      color: #999;
      font-size: 13px;
      i {
        color: #fe8f8a;
        opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #fe4d45;
      cursor: pointer;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid #fe4d45;
      color: #fe4d45;
      transition: all 0.2s;
      &:hover {
        background-color: #fe4d45;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #fe4d45;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
    .rule-tip {
      margin-top: 8px;
    }
    .act-tip {
      white-space: nowrap;
      color: #ff0000;
    }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #fe4d45;
        border-bottom: 1px solid #fe4d45;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #fe4d45;
        border-left: 1px solid #fe4d45;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      // font-family: system-ui;
      font-family: PingFang SC;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
.miniAppPic{
  position: relative;
  .image-slot{
    width: 100%;
    height: 100%;
    background: #f5f7fa;
    text-align: center;
    padding-top: 43px;
    i{
      font-size: 30px;
      color: #909399;
    }
  }
  .top{
    position: relative;
    left: 8px;
    display: flex;
    .returnBtn{
      border-radius: 4px;
      width: auto;
      height: 32px;
      line-height: 32px;
      text-align: center;
      color:#fe4d45;
      background: rgba(254, 77, 69, 0.1);
      border: 1px solid #fe4d45;
      &:hover{
        color: #fff;
        background: #fe4d45;
      }
    }
    .reset{
      color: #fe4d45;
      cursor: pointer;
      font-size: 14px;
      margin-left: 15px;
    }
  }
  .bottom{
    position: relative;
    top: 15px;
    margin-left: 115px;
    .elImg{
      width: 120px; 
      height: 120px;
      border: 1px dashed #dddddd;
      border-radius: 5px;
    }
    .tips1{
      position: absolute;
      left: 135px;
      top: 22px;
      line-height:2;
      color: #aaaaaa;
      font-size: 13px;
    }
  }
}
.task-wrap{
  display: flex;
  align-items: center;
  &-radio{
    margin-right: 10px;
  }
}
.book-good-wrap{
  display: flex;
  align-items: center;
}
.tip-red{
  color: red;
}
.task-tip-wrap{
  padding-right: 10%;
}
.skuType-label {
  /deep/ .el-form-item__label {
    padding-right: 3px;
  }
}
.w120 {
  width: 120px;
}
.w180 {
  width: 180px;
}
.bold-toggle-btn {
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  color: #606266;
  font-size: 16px;
  cursor: pointer;
  user-select: none;
  transition: all 0.2s;
  .bold-toggle-text {
    font-weight: normal;
    line-height: 1;
  }
  &.is-active {
    color: #3159FF;
    border-color: #3159FF;
    .bold-toggle-text {
      font-weight: bold;
    }
  }
  &.is-disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
}
</style>
<style lang="scss">
.createPlayStep {
  // .el-step.is-horizontal .el-step__line {
  //   height: 1px;
  // }
  // .el-step__head.is-success {
  //   color: #fe4d45;
  //   border-color: #fe4d45;
  //   .el-step__line {
  //     background-color: #fe4d45;
  //   }
  // }
  // .el-step__head.is-process {
  //   color: #fe4d45;
  //   border-color: #fe4d45;
  // }
  // .el-step__title.is-process {
  //   color: #fe4d45;
  // }
  // .el-step__title.is-success {
  //   color: #fe4d45;
  // }
  .textarea {
    .el-textarea__inner {
      min-height: 120px !important;
    }
  }
  .el-step__main {
    position: absolute;
    top: -7px;
    left: 33px;
  }
  .el-step__head.is-process {
    position: absolute;
  }
  .el-step.is-horizontal .el-step__line {
    left: 107px;
    right: 15px;
  }
  .el-step {
    position: relative;
  }
}
.task-btn-wrap{
  margin-bottom: 16px;
}
.task-tip{
  margin-bottom: 16px;
}

.rule_box {
  // width: 1000px;
  // height: 217px;
  width: 100%;
  background: #fafafa;
  padding: 10px;
  border-radius: 4px;
  font-size: 14px;
  &_top {
    margin: 0 0 10px 15px;
  }
  &_middle {
    margin-left: 10px;
    .middle-box {
      display: flex;
      align-items: center;
      &_tip {
        color: #ff0000;
      }
    }
  }
  &_bottom {
    margin-left: 7px;
  }
}
.tip-box{
  font-size: 13px;
  color: #ff0000;
}
.ml8 {
  margin-left: 8px;
}
.mr8 {
  margin-right: 8px;
}
</style>
